/**
 * ---------------------------------------------------
 *  AVISO IMPORTANTE!
 *  Qualquer informação alterada nesse arquivo deverá ser atualizado no arquivo de modelo do Perfil Hospitalar.
 *  LOCAL DO ARQUIVO: /assets/PerfilHospitalar.pdf
 * ---------------------------------------------------
 */

import React, { useState, useEffect, useCallback } from 'react';

import { useForm } from 'react-hook-form';

import { format, parseISO } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

import { MdExpandLess, MdError, MdClear } from 'react-icons/md';
import { IoMdArrowBack } from 'react-icons/io';

import { ClipLoader } from 'react-spinners';

import { Col, Row, Button, Checkbox, Input, Radio, Tooltip } from 'antd';

import Swal from 'sweetalert2';

import { toast } from 'react-toastify';

import jwt_decode from 'jwt-decode';

import { useSelector, useDispatch } from 'react-redux';

import {
  signInSuccess,
  perfilInstituicaoUpdate,
} from '~/store/modules/auth/actions';

import { opcoesPerfilSuccess } from '~/store/modules/instituitions/actions';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import Breadcumbs from '~/components/Breadcumbs';

import PdfPerfilHospitalar from '../../assets/PerfilHospitalar.pdf';

import {
  PageTitle,
  BoxInfoUpdate,
  BoxContent,
  Content,
  TitleSection,
  BoxInput,
  Label,
  BoxForm,
  BoxRadiosInline,
  BoxRadios,
  BoxCheckboxs,
  CheckboxBg,
  ButtonBox,
  BoxdiagnosticoTerapeutico,
  ButtonTop,
  ExceptionsBox,
} from './style';

import iconLock from '~/assets/icons/lock-update.svg';

import {
  modalConfirm,
  modalPdf,
  modalSuccess,
  modalValidade,
  modalSuccessReabertura,
} from './dados/optionsModal';
import ReportDataProfile from './components/ReportDataProfile';
import { onlyNumbers } from '~/helpers/generalFunctions';
import ButtonBase from '~/components/Button';
import { AiOutlineDownload } from 'react-icons/ai';
import { CSVLink } from 'react-csv';

const PerfilDoHospital = props => {
  const { register, handleSubmit, errors } = useForm();
  const { token, roles, cnes, systemConfig } = store.getState().auth;

  const dispatch = useDispatch();

  const defaultHeaders = {
    headers: {
      Authorization: token,
    },
  };

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
  const ROLE_MANAGER = roles.includes('ROLE_MANAGER');

  const decodedToken = jwt_decode(token?.split(' ')[1]);

  const { name } = decodedToken;

  const [loading, setLoading] = useState(true);

  // INFORMAÇÕES DO PERFIL

  const [naoCadastrouPerfil, setNaoCadastrouPerfil] = useState(false);

  const [desbloqueado, setDesbloqueado] = useState(null);

  const [hasProfile, setHasProfile] = useState(false);
  const [profileDataCsv, setProfileDataCsv] = useState(null);

  const [dataNovaAtualizacao, setDataNovaAtualizacao] = useState();
  const [dataCriacao, setDataCriacao] = useState();

  const [cnesCadastro, setCnesCadastro] = useState();
  const [nomeUsuarioCadastro, setNomeUsuarioCadastro] = useState();

  // OBTER OPÇÕES DO PERFIL HOSPITALAR
  const [opcoesPerfilHospitalar, setOpcoesPerfilHospitalar] = useState(null);

  const [tipoHospital, setTipoHospital] = useState('');
  const [tipoEstabelecimento, setTipoEstabelecimento] = useState([]);

  const [perfilEtario, setPerfilEtario] = useState([]);

  const [perfilInternacaoHospitalar, setPerfilInternacaoHospitalar] = useState([]);
  const [procedimentosCirurgicos, setProcedimentosCirurgicos] = useState();

  const [corpoClinicoHospital, setCorpoClinicoHospital] = useState('');
  const [instituicaoDeEnsino, setInstituicaoDeEnsino] = useState();
  const [programaDeResidencia, setProgramaDeResidencia] = useState();
  const [metricaNPS, setMetricaNPS] = useState();
  const [ultimaPontuacaoNPS, setUltimaPontuacaoNPS] = useState(null);

  const [totalDeMedicos, setTotalDeMedicos] = useState();
  const [totalDeEnfermeiros, setTotalDeEnfermeiros] = useState();
  const [totalDeTecnicos, setTotalDeTecnicos] = useState();
  const [totalDeEmpregados, setTotalDeEmpregados] = useState();
  const [usoDRG, setUsoDRG] = useState();
  const [
    usoProtocolosClinicosInstitucionais,
    setUsoProtocolosClinicosInstitucionais,
  ] = useState();
  const [
    qualProtocoloClinicoInstitucional,
    setQualProtocoloClinicoInstitucional,
  ] = useState([]);
  const [
    usaProntuarioSistemaInformatizado,
    setUsaProntuarioSistemaInformatizado,
  ] = useState();

  const [
    sistemaInformatizadoProntuario,
    setSistemaInformatizadoProntuario,
  ] = useState([]);

  const [
    usaProgramaAvaliacaoIndicadoresHospitalar,
    setUsaProgramaAvaliacaoIndicadoresHospitalar,
  ] = useState();

  const [
    sistemaInformatizadoAvaliacao,
    setSistemaInformatizadoAvaliacao,
  ] = useState([]);

  const [
    outrosAvaliacaoIndicadoresHospitalar,
    setOutrosAvaliacaoIndicadoresHospitalar,
  ] = useState();

  const [certificadoPrograma, setCertificadoPrograma] = useState([]);
  const [usaCertificadoPrograma, setUsaCertificadoPrograma] = useState();
  const [outrosCertificadoPrograma, setOutrosCertificadoPrograma] = useState();

  const [possuiAtendimentoEmergencia, setPossuiAtendimentoEmergencia] = useState();
  const [atendimentoEmergencia, setAtendimentoEmergencia] = useState([]);


  const [
    monitoramentoDeIndicadores,
    setMonitoramentoDeIndicadores,
  ] = useState();

  const [numeroDeLeitos, setNumeroDeLeitos] = useState();

  const [coordenaEstudosClinicos, setCoordenaEstudosClinicos] = useState();
  const [possuiUnidadeDeEmergencia, setPossuiUnidadeDeEmergencia] = useState();

  const [
    possuiEmergenciaEspecializada,
    setPossuiEmergenciaEspecializada,
  ] = useState();

  const [emergenciaEspecializada, setEmergenciaEspecializada] = useState([]);

  const [
    outrosEmergenciaEspecializada,
    setOutrosEmergenciaEspecializada,
  ] = useState();

  const [
    estratificacaoDeRiscoNaEmergencia,
    setEstratificacaoDeRiscoNaEmergencia,
  ] = useState();

  const [estratificacoesDeRisco, setEstratificacoesDeRisco] = useState([]);

  const [
    estratificacaoRiscoAtsTipo,
    setEstratificacaoRiscoAtsTipo,
  ] = useState();

  const [
    estratificacaoRiscoCtasTipo,
    setEstratificacaoRiscoCtasTipo,
  ] = useState();

  const [
    estratificacaoRiscoMtsTipo,
    setEstratificacaoRiscoMtsTipo,
  ] = useState();

  const [
    estratificacaoRiscoEsiTipo,
    setEstratificacaoRiscoEsiTipo,
  ] = useState();

  const [
    outrosEstratificacoesDeRisco,
    setOutrosEstratificacoesDeRisco,
  ] = useState();

  const [totalDeLietosEmergencia, setTotalDeLietosEmergencia] = useState();

  const [atendeEmergenciaAdulto, setAtendeEmergenciaAdulto] = useState();
  const [
    atendeEmergenciaPediatrico,
    setAtendeEmergenciaPediatrico,
  ] = useState();

  // State > Outros Serviços/Unidades
  const [timeDeRespostaRapida, setTimeDeRespostaRapida] = useState();

  const [atendeNeonatal, setAtendeNeonatal] = useState();

  const [totalLeitoUTINeonatal, setTotalLeitoUTINeonatal] = useState();
  const [
    totalEnfermeirosUTINeonatal,
    setTotalEnfermeirosUTINeonatal,
  ] = useState();

  const [atendePediatrico, setAtendePediatrico] = useState();
  const [totalLeitoUTIPediatrico, setTotalLeitoUTIPediatrico] = useState();
  const [
    totalEnfermeirosUTIPediatrico,
    setTotalEnfermeirosUTIPediatrico,
  ] = useState();

  const [atendeAdulto, setAtendeAdulto] = useState();
  const [totalLeitoUTIAdulto, setTotalLeitoUTIAdulto] = useState();
  const [totalEnfermeirosUTIAdulto, setTotalEnfermeirosUTIAdulto] = useState();

  const [possuiUnidadeCoronariana, setPossuiUnidadeCoronariana] = useState();
  const [
    possuiUnidadeInternacaoCirurgica,
    setPossuiUnidadeInternacaoCirurgica,
  ] = useState();
  const [
    possuiUnidadeInternacaoClinicaMedica,
    setPossuiUnidadeInternacaoClinicaMedica,
  ] = useState();
  const [
    possuiUnidadeInternacaoObstetricaNeonatal,
    setPossuiUnidadeInternacaoObstetricaNeonatal,
  ] = useState();
  const [
    possuiUnidadeInternacaoPediatrica,
    setPossuiUnidadeInternacaoPediatrica,
  ] = useState();
  const [
    possuiUnidadeInternacaoTraumatoOrtopedica,
    setPossuiUnidadeInternacaoTraumatoOrtopedica,
  ] = useState();

  const [possuiUnidadeAVC, setPossuiUnidadeAVC] = useState();
  const [terapiaFibrinolitica, setTerapiaFibrinolitica] = useState();
  const [trombectomia, setTrombectomia] = useState();

  const [unidadeSemiIntensiva, setUnidadeSemiIntensiva] = useState();

  const [possuiBlocoCirurgico, setPossuiBlocoCirurgico] = useState();
  const [quantasSalasDeCirurgia, setQuantasSalasDeCirurgia] = useState();

  const [possuiCentroObstestrico, setPossuiCentroObstestrico] = useState();
  const [quantasSalasDeParto, setQuantasSalasDeParto] = useState();

  const [possuiUTI, setPossuiUTI] = useState();

  const [
    possuiUnidadeTratamentoIntensivoEspecializada,
    setPossuiUnidadeTratamentoIntensivoEspecializada,
  ] = useState();

  const [utiEspecializada, setUtiEspecializada] = useState([]);

  const [outroTipoHospital, setOutroTipoHospital] = useState('');

  const [diagnosticoTerapeutico, setDiagnosticoTerapeutico] = useState([]);
  const [atendimento24Hemodinamica, setAtendimento24Hemodinamica] = useState();

  const [exceptions, setExceptions] = useState();

  // CHECKBOXS OUTROS

  const [outrosAval_IndicHospitalar, setOutrosAval_IndicHospitalar] = useState(
    false
  );

  const [outrosCertif_Programa, setOutrosCertif_Programa] = useState(false);

  const [outrosEmerg_Especializada, setOutrosEmerg_Especializada] = useState(
    false
  );

  const [outrosEstratif_DeRisco, setOutrosEstratif_DeRisco] = useState(false);

  const [outroTipo_Hospital, setOutroTipo_Hospital] = useState(false);

  const [perfilHabilitado, setPerfilHabilitado] = useState(false);

  const [redeAssistencial, setRedeAssistencial] = useState(false);
  const [redeAssistencialCnpj, setRedeAssistencialCnpj] = useState(null);
  const [redeAssistencialRazao, setRedeAssistencialRazao] = useState(null);
  const [sistemasEletronicosHospital, setSistemasEletronicosHospital] = useState("");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  // OBTER DADOS DO PERFIL FORMULÁRIO
  const idInst = sessionStorage.getItem('institutionId');
  const obterOpcoesPerfilHospitalar = async () => {
    try {
      const response = await api.get(`instituicoes/opcoes-perfil-hospitalar`, {
        headers: {
          Authorization: token,
        },
      });
      setOpcoesPerfilHospitalar(response.data);

      dispatch(opcoesPerfilSuccess(response.data));

      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const downloadCsv = useCallback(async () => {
    let response;

    try {
      if (ROLE_ADMIN) {
        const idInstituicao = props.location.state.id;
        response = await api.get(
          `/instituicoes/${idInstituicao}/download-csv`,
          defaultHeaders
        );
      } else {
        response = await api.get(`/instituicoes/download-csv`, defaultHeaders);
      }

      setProfileDataCsv(response.data);
    } catch (error) {
      //
    }
  }, [setProfileDataCsv]);



  const getPerfilHospitalar = async () => {
    setLoading(true);
    try {
      let response;
      if (ROLE_ADMIN) {
        const idInstituicao = props.location.state.id;

        try {
          response = await api.get(
            `/instituicoes/${idInstituicao}/perfil-hospitalar`,
            {
              headers: {
                Authorization: token,
              },
            }
          );

          setLoading(false);
        } catch (error) {
          setNaoCadastrouPerfil(true);
          setLoading(false);
        }
      } else {
        response = await api.get(`/instituicoes/perfil-hospitalar`, {
          headers: {
            Authorization: token,
          },
        });
      }

      if (String(response?.status).substr(0, 2) === '20') {
        setLoading(false);
        downloadCsv();
        setHasProfile(true);
        const { data } = response;

        setCnesCadastro(data.cnes);
        setNomeUsuarioCadastro(data.nomeUsuarioCadastro);
        setDesbloqueado(data.desbloqueado);
        setDataNovaAtualizacao(parseISO(data.dataNovaAtualizacao));
        setDataCriacao(data.dataCriacao);
        setTipoHospital(data.tipoHospital);
        setOutroTipoHospital(data.outroTipoHospital);
        setNumeroDeLeitos(data.numeroDeLeitos);
        setPerfilEtario(data.perfilEtario);
        setProcedimentosCirurgicos(data.procedimentosCirurgicos);
        setCorpoClinicoHospital(data.corpoClinicoHospital);
        setInstituicaoDeEnsino(data.instituicaoDeEnsino);
        setProgramaDeResidencia(data.programaDeResidencia);
        setMetricaNPS(data.metricaNPS);
        setUltimaPontuacaoNPS(data.ultimaPontuacaoNPS);
        setTotalDeMedicos(data.totalDeMedicos);
        setTotalDeEnfermeiros(data.totalDeEnfermeiros);
        setTotalDeTecnicos(data.totalDeTecnicos);
        setTotalDeEmpregados(data.totalDeEmpregados);
        setUsoDRG(data.usoDRG);
        setUsoProtocolosClinicosInstitucionais(
          data.usoProtocolosClinicosInstitucionais
        );
        setQualProtocoloClinicoInstitucional(
          data.protocolosClinicosInstitucionais
        );
        setUsaProntuarioSistemaInformatizado(
          data.usoProtocolosClinicosInstitucionais
        );
        setSistemaInformatizadoProntuario(data.sistemaInformatizadoProntuario);
        setUsaProgramaAvaliacaoIndicadoresHospitalar(
          data.usaProgramaAvaliacaoIndicadoresHospitalar
        );
        setSistemaInformatizadoAvaliacao(data.sistemaInformatizadoAvaliacao);
        setOutrosAvaliacaoIndicadoresHospitalar(
          data.outrosAvaliacaoIndicadoresHospitalar
        );
        setUsaCertificadoPrograma(data.usaCertificadoPrograma);
        setCertificadoPrograma(data.certificadoPrograma);
        setOutrosCertificadoPrograma(data.outrosCertificadoPrograma);
        setMonitoramentoDeIndicadores(data.monitoramentoDeIndicadores);
        setCoordenaEstudosClinicos(data.coordenaEstudosClinicos);
        setPossuiUnidadeDeEmergencia(data.possuiUnidadeDeEmergencia);
        setAtendimentoEmergencia(data?.atendimentoEmergencia?.[0] ? [data.atendimentoEmergencia[0]] : []);
        setPossuiAtendimentoEmergencia(!!data.atendimentoEmergencia);
        setPossuiEmergenciaEspecializada(data.possuiEmergenciaEspecializada);
        setEmergenciaEspecializada(data.emergenciaEspecializada);
        setOutrosEmergenciaEspecializada(data.outrosEmergenciaEspecializada);
        setEstratificacaoDeRiscoNaEmergencia(data.estratificacaoDeRiscoNaEmergencia);
        setEstratificacoesDeRisco(data.estratificacoesDeRisco);
        setOutrosEstratificacoesDeRisco(data.outrosEstratificacoesDeRisco);
        setTotalDeLietosEmergencia(data.totalDeLietosEmergencia);
        setAtendeEmergenciaAdulto(data.atendeEmergenciaAdulto);
        setAtendeEmergenciaPediatrico(data.atendeEmergenciaPediatrico);
        setTimeDeRespostaRapida(data.timeDeRespostaRapida);
        setPossuiUTI(data.possuiUTI);
        setAtendeNeonatal(data.atendeNeonatal);
        setAtendePediatrico(data.atendePediatrico);
        setAtendeAdulto(data.atendeAdulto);
        setTotalLeitoUTINeonatal(data.totalLeitoUTINeonatal);
        setTotalLeitoUTIPediatrico(data.totalLeitoUTIPediatrico);
        setTotalLeitoUTIAdulto(data.totalLeitoUTIAdulto);
        setTotalEnfermeirosUTINeonatal(data.totalEnfermeirosUTINeonatal);
        setTotalEnfermeirosUTIPediatrico(data.totalEnfermeirosUTIPediatrico);
        setTotalEnfermeirosUTIAdulto(data.totalEnfermeirosUTIAdulto);
        setPossuiBlocoCirurgico(data.possuiBlocoCirurgico);
        setQuantasSalasDeCirurgia(data.quantasSalasDeCirurgia);
        setPossuiCentroObstestrico(data.possuiCentroObstestrico);
        setQuantasSalasDeParto(data.quantasSalasDeParto);
        setPossuiUnidadeAVC(data.possuiUnidadeAVC);
        setPossuiUnidadeCoronariana(data.possuiUnidadeCoronariana);
        setPossuiUnidadeInternacaoCirurgica(
          data.possuiUnidadeInternacaoCirurgica
        );
        setPossuiUnidadeInternacaoClinicaMedica(
          data.possuiUnidadeInternacaoClinicaMedica
        );
        setPossuiUnidadeInternacaoObstetricaNeonatal(
          data.possuiUnidadeInternacaoObstetricaNeonatal
        );
        setPossuiUnidadeInternacaoPediatrica(
          data.possuiUnidadeInternacaoPediatrica
        );
        setPossuiUnidadeInternacaoTraumatoOrtopedica(
          data.possuiUnidadeInternacaoTraumatoOrtopedica
        );
        setPossuiUnidadeTratamentoIntensivoEspecializada(
          data.possuiUnidadeTratamentoIntensivoEspecializada
        );
        setEstratificacaoRiscoAtsTipo(data.estratificacaoRiscoAtsTipo);
        setEstratificacaoRiscoCtasTipo(data.estratificacaoRiscoCtasTipo);
        setEstratificacaoRiscoMtsTipo(data.estratificacaoRiscoMtsTipo);
        setEstratificacaoRiscoEsiTipo(data.estratificacaoRiscoEsiTipo);
        setTerapiaFibrinolitica(data.terapiaFibrinolitica);
        setTrombectomia(data.trombectomia);
        setUnidadeSemiIntensiva(data.unidadeSemiIntensiva);
        setDiagnosticoTerapeutico(data.diagnosticoTerapeutico);
        setPerfilInternacaoHospitalar(data.perfilInternacaoHospitalar);
        setTipoEstabelecimento(data.tipoEstabelecimento);
        setUtiEspecializada(data.utiEspecializada);
        setAtendimento24Hemodinamica(data.atendimento24Hemodinamica);
        if (data?.outroTipoHospital) {
          setOutroTipo_Hospital(true);
        }
        if (
          data?.outrosAvaliacaoIndicadoresHospitalar &&
          data?.usaProgramaAvaliacaoIndicadoresHospitalar
        ) {
          setOutrosAval_IndicHospitalar(true);
        }
        if (data?.outrosCertificadoPrograma && data?.usaCertificadoPrograma) {
          setOutrosCertif_Programa(true);
        }
        if (data.outrosEmergenciaEspecializada) {
          setOutrosEmerg_Especializada(true);
        }
        if (data.outrosEstratificacoesDeRisco) {
          setOutrosEstratif_DeRisco(true);
        }
        validarParfil(parseISO(data.dataNovaAtualizacao));

        if (data.redeAssistencial) {
          setRedeAssistencial(true);
        }
        if (data.redeAssistencialCnpj) {
          setRedeAssistencialCnpj(data.redeAssistencialCnpj);
        }
        if (data.redeAssistencialRazao) {
          setRedeAssistencialRazao(data.redeAssistencialRazao);
        }
        if (data.sistemasEletronicosHospital) {
          setSistemasEletronicosHospital(data.sistemasEletronicosHospital);
        }

      }
    } catch (error) {
      if (error?.response?.data?.cause === 'Data not found') {
        setDesbloqueado(true);
      }
      setLoading(false);
    }

  };

  function validarParfil(data) {
    const today = new Date();
    
    console.log(today);
    console.log(data);

    if (data.getTime() >= today.getTime()) {
      setPerfilHabilitado(true);
    }


    console.log(perfilHabilitado);

  }

  // SALVAR PERFIL DO HOSPITAL

  const dadosPerfil = {
    atendimento24Hemodinamica: atendimento24Hemodinamica,
    certificadoPrograma: certificadoPrograma,
    usaCertificadoPrograma: usaCertificadoPrograma,
    outrosCertificadoPrograma: outrosCertificadoPrograma,
    coordenaEstudosClinicos: coordenaEstudosClinicos,
    corpoClinicoHospital: corpoClinicoHospital,
    diagnosticoTerapeutico: diagnosticoTerapeutico,
    estratificacoesDeRisco: estratificacoesDeRisco,
    outrosEstratificacoesDeRisco: outrosEstratificacoesDeRisco,
    estratificacaoRiscoAtsTipo,
    estratificacaoRiscoCtasTipo,
    estratificacaoRiscoEsiTipo,
    estratificacaoRiscoMtsTipo,
    estruturaFisica: 'mo',
    procedimentosCirurgicos: procedimentosCirurgicos,
    instituicaoDeEnsino: instituicaoDeEnsino,
    metricaNPS: metricaNPS,
    monitoramentoDeIndicadores: monitoramentoDeIndicadores,
    numeroDeLeitos: numeroDeLeitos,
    perfilEtario: perfilEtario,
    possuiBlocoCirurgico: possuiBlocoCirurgico,
    quantasSalasDeCirurgia,
    possuiCentroObstestrico: possuiCentroObstestrico,
    quantasSalasDeParto,
    terapiaFibrinolitica,
    trombectomia,
    possuiUnidadeDeEmergencia: possuiUnidadeDeEmergencia,
    possuiEmergenciaEspecializada: possuiEmergenciaEspecializada,
    outrosEmergenciaEspecializada: outrosEmergenciaEspecializada,
    emergenciaEspecializada: emergenciaEspecializada,
    estratificacaoDeRiscoNaEmergencia: estratificacaoDeRiscoNaEmergencia,
    atendeEmergenciaAdulto: atendeEmergenciaAdulto,
    atendeEmergenciaPediatrico: atendeEmergenciaPediatrico,
    atendimentoEmergencia: atendimentoEmergencia,
    totalDeLietosEmergencia: totalDeLietosEmergencia,
    possuiUTI: possuiUTI,
    possuiUnidadeAVC: possuiUnidadeAVC,
    unidadeSemiIntensiva: unidadeSemiIntensiva,
    programaDeResidencia: programaDeResidencia,
    protocolosClinicosInstitucionais: qualProtocoloClinicoInstitucional,
    sistemaInformatizadoAvaliacao: sistemaInformatizadoAvaliacao,
    outrosAvaliacaoIndicadoresHospitalar: outrosAvaliacaoIndicadoresHospitalar,
    sistemaInformatizadoProntuario: sistemaInformatizadoProntuario,
    timeDeRespostaRapida: timeDeRespostaRapida,
    tipoHospital: tipoHospital,
    totalDeEmpregados: totalDeEmpregados,
    totalDeEnfermeiros: totalDeEnfermeiros,
    totalDeMedicos: totalDeMedicos,
    totalDeTecnicos: totalDeTecnicos,
    ultimaPontuacaoNPS: ultimaPontuacaoNPS,
    usaProgramaAvaliacaoIndicadoresHospitalar: usaProgramaAvaliacaoIndicadoresHospitalar,
    usaProntuarioSistemaInformatizado: usaProntuarioSistemaInformatizado,
    usoDRG: usoDRG,
    usoProtocolosClinicosInstitucionais: usoProtocolosClinicosInstitucionais,
    possuiUnidadeCoronariana: possuiUnidadeCoronariana,
    possuiUnidadeInternacaoCirurgica: possuiUnidadeInternacaoCirurgica,
    possuiUnidadeInternacaoClinicaMedica: possuiUnidadeInternacaoClinicaMedica,
    possuiUnidadeInternacaoObstetricaNeonatal: possuiUnidadeInternacaoObstetricaNeonatal,
    possuiUnidadeInternacaoPediatrica: possuiUnidadeInternacaoPediatrica,
    possuiUnidadeInternacaoTraumatoOrtopedica: possuiUnidadeInternacaoTraumatoOrtopedica,
    possuiUnidadeTratamentoIntensivoEspecializada: possuiUnidadeTratamentoIntensivoEspecializada,
    atendeNeonatal,
    totalLeitoUTINeonatal,
    totalEnfermeirosUTINeonatal,
    atendePediatrico,
    totalLeitoUTIPediatrico,
    totalEnfermeirosUTIPediatrico,
    atendeAdulto,
    totalLeitoUTIAdulto,
    totalEnfermeirosUTIAdulto,
    outroTipoHospital: outroTipoHospital,
    perfilInternacaoHospitalar: perfilInternacaoHospitalar,
    tipoEstabelecimento: tipoEstabelecimento,
    utiEspecializada: utiEspecializada,
    redeAssistencial: redeAssistencial,
    redeAssistencialCnpj: redeAssistencialCnpj,
    redeAssistencialRazao: redeAssistencialRazao,
    sistemasEletronicosHospital: sistemasEletronicosHospital
  };

  const savePerfilHospitalar = async data => {
    setExceptions(null);
    setLoading(true);

    try {
      const response = await api.post(
        `instituicoes/${idInst}/perfil-hospitalar`,
        dadosPerfil,
        {
          headers: {
            Authorization: String(token),
          },
        }
      );

      setLoading(false);

      const dataCriacao = String(response?.data?.dataCriacao).split(' ')[0];

      try {
        // Atualiza status na store do redux
        const formatDate = dataCriacao.split('-');
        const newDate = `${formatDate[2]}/${formatDate[1]}/${formatDate[0]}`;
        console.log('newDate', newDate);
        dispatch(perfilInstituicaoUpdate({ newDate }));
      } catch {
        //
      }

      if (String(response?.status).substr(0, 2) === '20') {
        Swal.fire(modalSuccess).then(result => {
          if (result.value) {
            window.location.reload();
          }
        });
      }
    } catch (error) {
      const fields = error?.response?.data?.fields;
      setExceptions(fields);
      if (error && error?.response?.data) {
        setLoading(false);
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Não foi possível cadastrar o perfil do hospital. Verifique os erros e tente novamente. </p>`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        }).then(res => {
          window.scrollTo({ top: 382, left: 0, behavior: 'smooth' });
        });
      }
    }
  };

  // Submit profile

  const [showProfileResume, setShowProfileResume] = useState(false);

  const submitProfileResume = useCallback(() => {
    setShowProfileResume(true);
  }, []);

  const onSubmit = dadosPerfilValues => {
    Swal.fire(modalConfirm).then(result => {
      if (result.value) {
        savePerfilHospitalar(dadosPerfilValues);
      }
    });
  };

  useEffect(() => {
    obterOpcoesPerfilHospitalar();
    getPerfilHospitalar();
  }, []);

  useEffect(() => {
    if (desbloqueado && ROLE_MANAGER) {
      setTimeout(() => {
        Swal.fire(modalValidade).then(({ value }) => {
          if (!value) {
            Swal.fire(modalPdf);
          }
        });
      }, 1000);
    }
  }, [desbloqueado]);

  useEffect(() => {
    const resultCountErrors = Object.keys(errors).length;
    if (resultCountErrors >= 1) {
      toast.error('Atenção aos campos de preenchimento obrigatório.', {
        autoClose: 10000,
      });
    }
  }, [errors]);

  const onChangeTipoEstabelecimento = useCallback(
    values => {
      setTipoEstabelecimento([...values]);
    },
    [tipoEstabelecimento]
  );

  const onChangePerfilInternacaoHospitalar = useCallback(
    values => {
      setPerfilInternacaoHospitalar([...values]);
    },
    [perfilInternacaoHospitalar]
  );

  const onChangeQualProtocoloClinicoInstitucional = useCallback(
    values => {
      setQualProtocoloClinicoInstitucional([...values]);
    },
    [qualProtocoloClinicoInstitucional]
  );

  const onChangePerfilEtario = useCallback(
    values => {
      setPerfilEtario([...values]);
    },
    [perfilEtario]
  );

  const onChangeSistemaInformatizadoProntuario = useCallback(
    values => {
      setSistemaInformatizadoProntuario([...values]);
    },
    [sistemaInformatizadoProntuario]
  );

  const onChangeSistemaInformatizadoAvaliacao = useCallback(
    values => {
      const filterValues = values.filter(value => {
        return value !== undefined;
      });

      setSistemaInformatizadoAvaliacao([...filterValues]);
    },
    [sistemaInformatizadoAvaliacao]
  );

  const onChangeCertificadoPrograma = useCallback(
    values => {
      const filterValues = values.filter(value => {
        return value !== undefined;
      });

      setCertificadoPrograma([...filterValues]);
    },
    [certificadoPrograma]
  );

  const onChangeEmergenciaEspecializada = useCallback(
    values => {
      const filterValues = values.filter(value => {
        return value !== undefined;
      });

      setEmergenciaEspecializada([...filterValues]);
    },

    [emergenciaEspecializada]
  );

  const onChangeEstratificacoesDeRisco = useCallback(
    values => {
      const filterValues = values.filter(value => {
        return value !== undefined;
      });

      setEstratificacoesDeRisco([...filterValues]);

      if (!values?.includes('estratificacao_risco_ats')) {
        setEstratificacaoRiscoAtsTipo(null);
      }

      if (!values?.includes('estratificacao_risco_ctas')) {
        setEstratificacaoRiscoCtasTipo(null);
      }

      if (!values?.includes('estratificacao_risco_mts')) {
        setEstratificacaoRiscoMtsTipo(null);
      }

      if (!values?.includes('estratificacao_risco_esi')) {
        setEstratificacaoRiscoEsiTipo(null);
      }
    },
    [estratificacoesDeRisco]
  );

  const onChangeDiagnosticoTerapeutico = useCallback(
    values => {
      setDiagnosticoTerapeutico([...values]);

      if (!values?.includes('diagnotico_terapeutico_hemodinamica')) {
        setAtendimento24Hemodinamica(null);
      }
    },
    [diagnosticoTerapeutico]
  );

  const onChangeUtiEspecializada = useCallback(
    values => {
      setUtiEspecializada([...values]);
    },
    [utiEspecializada]
  );

  function createInnerHtml(texto) {
    return { __html: texto };
  }

  // Limpar dados dos

  const limparDados = useCallback(async () => {
    try {
      await api.get(`instituicoes-teste/profile/inativar/${cnes}`, {
        ...defaultHeaders,
      });
      window.location.reload();
    } catch (err) {
      //
    }
  }, []);

  async function retornarRazaoSocial(cnpj) {
   const response = await api.get(
      `instituicoes/${cnpj}/pesquisa`,
      {
        headers: {
          Authorization: String(token),
        },
      }
    );
    if (String(response?.status).substr(0, 2) === '20') {
      const { data } = response;
      if(data.razaoSocial != null){
      setRedeAssistencialRazao(data.razaoSocial);
      }else{
        setRedeAssistencialRazao("ESTE CNPJ NÃO É VÁLIDO NA RECEITA FEDERAL");
      }
    }

  }

  async function abrirPerfil() {
    const idInstituicao = props.location.state.id;
    const response = await api.post(
      `instituicoes/${idInstituicao}/open/perfil-hospitalar`,
      {
        headers: {
          Authorization: String(token),
        },
      }
    );

    if (String(response?.status).substr(0, 2) === '20') {
      Swal.fire(modalSuccessReabertura).then(result => {
        if (result.value) {
          window.location.reload();
        }
      });
    }

  }

  // Limpa outrosAvaliacaoIndicadoresHospitalar
  useEffect(() => {
    if (!outrosAval_IndicHospitalar) {
      setOutrosAvaliacaoIndicadoresHospitalar(null);
    }
  }, [outrosAval_IndicHospitalar]);

  // Limpa outrosCertificadoPrograma
  useEffect(() => {
    if (!outrosCertif_Programa) {
      setOutrosCertificadoPrograma(null);
    }
  }, [outrosCertif_Programa]);

  // Limpa outrosEstratificacoesDeRisco
  useEffect(() => {
    if (!outrosEstratif_DeRisco) {
      setOutrosEstratificacoesDeRisco(null);
    }
  }, [outrosEstratif_DeRisco]);

  // Limpa outroTipoHospital
  useEffect(() => {
    if (!outroTipo_Hospital) {
      setOutroTipoHospital(null);
    }
  }, [outroTipo_Hospital]);

  useEffect(() => {
    if (sistemaInformatizadoProntuario?.length > 0) {
      setUsaProntuarioSistemaInformatizado(true);
    }
  }, [sistemaInformatizadoProntuario]);

  return (
    <>
      {showProfileResume && (
        <ReportDataProfile
          onSubmit={onSubmit}
          dadosPerfil={dadosPerfil}
          showProfileResume={showProfileResume}
          setShowProfileResume={setShowProfileResume}
        />
      )}

      <Breadcumbs
        path="perfil-do-hospital"
        pathTitle="Perfil do hospital"
        routeId={props?.location?.state?.id}
      />
      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div className="pageTitle">
          <div>
            <span>Perfil do Hospital</span>
          </div>

          {hasProfile && (
            <CSVLink
              filename={`perfil-hospitalar-${cnes}.csv`}
              data={profileDataCsv || []}
              title="Perfil da instituição"
            >
              <ButtonBase variant="secondary">
                <AiOutlineDownload size={16} color="#FFF" /> Exportar Perfil
              </ButtonBase>
            </CSVLink>
          )}
        </div>
      </PageTitle>

      {loading ? (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      ) : (
        <BoxContent>
          {/* <button type="button" onClick={limparDados}>
            Limpar dados
          </button> */}

          <BoxInfoUpdate>
            <div>
              {ROLE_ADMIN ? (
                <>
                  {ROLE_ADMIN && perfilHabilitado ? (
                    <div onClick={abrirPerfil} style={{ backgroundColor: "#74a50a" }}>
                      <span style={{ color: 'white' }}>Liberar atualização de dados</span>

                    </div>
                  ) : (

                    <div>
                      <img src={iconLock} />
                      <span style={{ color: 'black' }}>Atualização de dados indisponível</span>
                    </div>

                  )}
                </>
              ) : (
                <>

                  {desbloqueado !== null && desbloqueado === false ? (
                    <div>
                      <img src={iconLock} />
                      <span>Atualização de dados indisponível</span>
                    </div>
                  ) : (
                    <br />
                  )}
                </>

              )}

              {dataCriacao && (
                <p>
                  Última atualização em:{' '}
                  <b>
                    {dataCriacao &&
                      format(new Date(`${dataCriacao}`), 'dd/MM/yyyy', {
                        locale: ptBR,
                      })}
                  </b>
                  <br />
                </p>
              )}

              {desbloqueado !== null && desbloqueado === false && (
                <p>
                  Próxima atualização em:{' '}
                  <b>
                    {dataNovaAtualizacao &&
                      format(new Date(`${dataNovaAtualizacao}`), 'dd/MM/yyyy', {
                        locale: ptBR,
                      })}
                  </b>
                </p>
              )}
            </div>
          </BoxInfoUpdate>

          <div className="title">
            {ROLE_ADMIN ? (
              <h2>
                Confira abaixo as informações de
                <br />
                <span>perfil do hospital:</span>
              </h2>
            ) : (
              <h2>
                Preencha as informações abaixo de acordo
                <br />
                com o <span> perfil do hospital:</span>
              </h2>
            )}
          </div>
          {exceptions && exceptions?.length > 0 && (
            <ExceptionsBox>
              <p>Erros: </p>
              {exceptions?.map(({ exception }) => {
                return (
                  <div>
                    <MdError size={15} color="#cc0000" />
                    <span> {exception} </span>
                  </div>
                );
              })}
            </ExceptionsBox>
          )}

          <Content>
            <form onSubmit={handleSubmit(submitProfileResume)}>
              <Row>
                <Col span={12}>
                  <BoxInput style={{ paddingRight: '40px' }}>
                    <Label>Nome do responsável pelo preenchimento: *</Label>
                    <input
                      name="nome"
                      type="text"
                      placeholder="Nome do responsável pelo preenchimento"
                      defaultValue={nomeUsuarioCadastro || name}
                      disabled
                    />
                  </BoxInput>
                </Col>
                <Col span={12}>
                  <BoxInput style={{ paddingLeft: '40px' }}>
                    <Label>CNES do Hospital: *</Label>
                    <input
                      name="cnes"
                      type="text"
                      placeholder="CNES do Hospital"
                      disabled
                      defaultValue={
                        ROLE_ADMIN ? cnesCadastro : cnesCadastro || cnes
                      }
                    />
                  </BoxInput>
                </Col>
              </Row>

              <hr />

              <BoxForm>
                <TitleSection> Perfil administrativo</TitleSection>

                {/*
                  *
                 1 - TIPO DE HOSPITAL
                  *
                */}

                <Row>
                  <Col span={18}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>1. Qual o tipo de estabelecimento?</Label>

                      <div className="inlineRadios">
                        <BoxRadios active={tipoHospital === 'g'}>
                          <Radio
                            checked={tipoHospital === 'g'}
                            onClick={() => {
                              setTipoHospital('g');
                              onChangeTipoEstabelecimento([]);
                              setOutroTipo_Hospital(null);
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Hospital Geral
                          </Radio>
                        </BoxRadios>
                        <BoxRadios active={tipoHospital === 'e'}>
                          <Radio
                            checked={tipoHospital === 'e'}
                            onClick={() => {
                              setTipoHospital('e');
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Hospital Especializado
                          </Radio>
                        </BoxRadios>
                      </div>
                    </BoxInput>
                  </Col>
                </Row>

                {tipoHospital === 'e' && (
                  <Row>
                    <Col span={24}>
                      <BoxInput style={{ paddingRight: '40px' }}>
                        <Label>
                          Se especializado, em qual área?{' '}
                          <span>(Marque todos que se aplicam)</span>
                        </Label>

                        <BoxCheckboxs>
                          <Checkbox.Group
                            style={{ width: '100%' }}
                            onChange={onChangeTipoEstabelecimento}
                            value={tipoEstabelecimento}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            <Row style={{ marginBottom: '0' }}>
                              {opcoesPerfilHospitalar &&
                                opcoesPerfilHospitalar.map(
                                  ({ grupo, valor, nome, descricao }) => {
                                    if (grupo === 'tipo_estabelecimento') {
                                      return (
                                        <Col span={8} key={valor}>
                                          <CheckboxBg
                                            selecionado={tipoEstabelecimento.includes(
                                              `${valor}`
                                            )}
                                          >
                                            <Checkbox checked value={valor}>
                                              {nome}
                                            </Checkbox>
                                          </CheckboxBg>
                                        </Col>
                                      );
                                    }
                                  }
                                )}
                            </Row>
                          </Checkbox.Group>
                        </BoxCheckboxs>
                        <Col span={8}>
                          <CheckboxBg selecionado={outroTipo_Hospital}>
                            <Checkbox
                              checked={outroTipo_Hospital}
                              onClick={() =>
                                setOutroTipo_Hospital(!outroTipo_Hospital)
                              }
                              onChange={e =>
                                setOutroTipoHospital(!outroTipoHospital)
                              }
                            >
                              <span
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  color: '#235f6e',
                                }}
                              >
                                Outro
                              </span>
                            </Checkbox>
                          </CheckboxBg>
                        </Col>
                      </BoxInput>
                    </Col>
                  </Row>
                )}

                {/*
                  *
                  . / 1- TIPO DE HOSPITAL
                  *
                */}

                {/*
                *
                2. Qual o número de leitos da instituição?
                *
                */}

                <Row>
                  <Col span={12}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>2. Qual o número de leitos da instituição?</Label>
                      <input
                        name="numeroDeLeitos"
                        value={numeroDeLeitos}
                        type="text"
                        onChange={({ target }) => {
                          setNumeroDeLeitos(onlyNumbers(target.value));
                        }}
                        ref={register({
                          required: true,
                          maxLength: 20,
                        })}
                        disabled={
                          ROLE_ADMIN || desbloqueado === false ? true : false
                        }
                      />
                      <p>(Somente números)</p>
                      {errors.totalDeLietosEmergencia && (
                        <span className="errorField">Campo obrigatório.</span>
                      )}
                    </BoxInput>
                  </Col>
                </Row>

                {/*
                *
                 ../ 2. Qual o número de leitos da instituição?
                *
                */}

                {/*
                  *

                  3. Qual o perfil etário de pacientes atendidos pela instituição?
                  *
               */}

                <Row>
                  <Col span={24}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>
                        3. Qual o perfil etário de pacientes atendidos pela
                        instituição? <span>(Marque todos que se aplicam)</span>
                      </Label>

                      <BoxCheckboxs perfilEtario={perfilEtario}>
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          onChange={onChangePerfilEtario}
                          value={perfilEtario}
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                        >
                          <Row>
                            {opcoesPerfilHospitalar &&
                              opcoesPerfilHospitalar.map(
                                ({ grupo, valor, nome, descricao }) => {
                                  if (grupo === 'perfil_etario') {
                                    return (
                                      <Col span={8} key={valor}>
                                        <CheckboxBg
                                          selecionado={perfilEtario.includes(
                                            `${valor}`
                                          )}
                                        >
                                          <Checkbox checked value={valor}>
                                            {nome}
                                          </Checkbox>
                                        </CheckboxBg>
                                      </Col>
                                    );
                                  }
                                }
                              )}
                          </Row>
                        </Checkbox.Group>
                      </BoxCheckboxs>
                    </BoxInput>
                  </Col>
                </Row>

                {/*
                  *
                  . / 3. Qual o perfil etário de pacientes atendidos pela instituição?
                  *
               */}

                {/*
                  *

               4. Quais os perfis de internação hospitalar?
                  *
               */}

                <Row>
                  <Col span={24}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>
                        4. Quais os perfis de internação hospitalar?{' '}
                        <span>(Marque todos que se aplicam)</span>
                      </Label>

                      <BoxCheckboxs>
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          value={perfilInternacaoHospitalar}
                          onChange={onChangePerfilInternacaoHospitalar}
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                        >
                          <Row>
                            {opcoesPerfilHospitalar &&
                              opcoesPerfilHospitalar.map(
                                ({ grupo, valor, nome, descricao }) => {
                                  if (
                                    grupo === 'perfil_internacao_hospitalar'
                                  ) {
                                    return (
                                      <Col span={8} key={valor}>
                                        <CheckboxBg
                                          selecionado={perfilInternacaoHospitalar.includes(
                                            `${valor}`
                                          )}
                                        >
                                          <Checkbox checked value={valor}>
                                            {nome}
                                          </Checkbox>
                                        </CheckboxBg>
                                      </Col>
                                    );
                                  }
                                }
                              )}
                          </Row>
                        </Checkbox.Group>
                      </BoxCheckboxs>
                    </BoxInput>
                  </Col>
                </Row>

                {/*
                  *
                  4. Quais os perfis de internação hospitalar?
                  *
               */}

               {/*
                  *
                 5. O hospital realiza procedimentos cirúrgicos? ( não inclui procedimentos endoscópicos)?
                  *
               */}
                <Row>
                  <Col span={24}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>5. O hospital realiza procedimentos cirúrgicos? (não inclui procedimentos endoscópicos)?</Label>

                      <Row>
                        <Col span={8}>
                          <BoxRadios active={procedimentosCirurgicos === true}>
                            <Radio
                              checked={procedimentosCirurgicos === true}
                              onClick={() => setProcedimentosCirurgicos(true)}
                              disabled={ROLE_ADMIN || !desbloqueado}
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={procedimentosCirurgicos === false}>
                            <Radio
                              checked={procedimentosCirurgicos === false}
                              onClick={() => setProcedimentosCirurgicos(false)}
                              disabled={ROLE_ADMIN || !desbloqueado}
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>
                    </BoxInput>
                  </Col>
                </Row>
                {/*
                  *
                 ./ 5. O hospital realiza procedimentos cirúrgicos? ( não inclui procedimentos endoscópicos)?
                  *
               */}

                {/*
                  *
                  6. Como é a relação do corpo clínico do hospital?
                  *
               */}
                <Row>
                  <Col span={24}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>
                        6. Como é a relação do corpo clínico do hospital?
                      </Label>

                      <Row>
                        <Col span={8}>
                          <BoxRadios active={corpoClinicoHospital === 'a'}>
                            <Radio
                              checked={corpoClinicoHospital === 'a'}
                              onClick={() => setCorpoClinicoHospital('a')}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Aberto
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={corpoClinicoHospital === 'f'}>
                            <Radio
                              checked={corpoClinicoHospital === 'f'}
                              onClick={() => setCorpoClinicoHospital('f')}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Fechado
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={corpoClinicoHospital === 'm'}>
                            <Radio
                              checked={corpoClinicoHospital === 'm'}
                              onClick={() => setCorpoClinicoHospital('m')}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Misto
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>
                    </BoxInput>
                  </Col>
                </Row>

                {/*
                  *
                  . / 6. Como é a relação do corpo clínico do hospital?
                  *
               */}

                {/*
                  *
                 7. A instituição é um hospital de ensino?
                  *
               */}
                <Row>
                  <Col span={24}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>7. A instituição é um hospital de ensino?</Label>

                      <Row>
                        <Col span={8}>
                          <BoxRadios active={instituicaoDeEnsino === true}>
                            <Radio
                              checked={instituicaoDeEnsino === true}
                              onClick={() => setInstituicaoDeEnsino(true)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={instituicaoDeEnsino === false}>
                            <Radio
                              checked={instituicaoDeEnsino === false}
                              onClick={() => setInstituicaoDeEnsino(false)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>
                    </BoxInput>
                  </Col>
                </Row>
                {/*
                  *
                 ./ 7. A instituição é um hospital de ensino?
                  *
               */}

                {/*
                  *
                 8. A instituição possui programa de residência?
                  *
               */}
                <Row>
                  <Col span={24}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>
                        8. A instituição possui programa de residência?
                      </Label>
                      <Row>
                        <Col span={8}>
                          <BoxRadios active={programaDeResidencia === true}>
                            <Radio
                              checked={programaDeResidencia === true}
                              onClick={() => setProgramaDeResidencia(true)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={programaDeResidencia === false}>
                            <Radio
                              checked={programaDeResidencia === false}
                              onClick={() => setProgramaDeResidencia(false)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>
                    </BoxInput>
                  </Col>
                </Row>
                {/*
                  *
                 8. A instituição possui programa de residência?
                  *
               */}

                {/*  TOTAL MÉDICOS / ENFERMEIROS */}

                <Row>
                  {/*
                    *
                    9. Total de médicos(as) que atuam na instituição:
                    *
                */}
                  <Col span={12}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>
                        9. Total de médicos(as) que atuam na instituição:
                      </Label>
                      <input
                        name="totalDeMedicos"
                        type="text"
                        value={totalDeMedicos}
                        onChange={({ target }) => {
                          setTotalDeMedicos(onlyNumbers(target.value));
                        }}
                        ref={register({
                          required: true,
                          maxLength: 20,
                        })}
                        disabled={
                          ROLE_ADMIN || desbloqueado === false ? true : false
                        }
                      />
                      <p>(Somente números)</p>
                      {errors.totalDeMedicos && (
                        <span className="errorField">Campo obrigatório.</span>
                      )}
                    </BoxInput>
                  </Col>
                  {/*
                    *
                    ./ 9. Total de médicos(as) que atuam na instituição:
                    *
                  */}

                  {/*
                    *
                    10. Total de enfermeiros(as) que atuam na instituição:
                    *
                  */}
                  <Col span={12}>
                    <BoxInput style={{ paddingLeft: '40px' }}>
                      <Label>
                        10. Total de enfermeiros(as) que atuam na instituição:
                      </Label>
                      <input
                        name="totalDeEnfermeiros"
                        type="text"
                        value={totalDeEnfermeiros}
                        onChange={({ target }) => {
                          setTotalDeEnfermeiros(onlyNumbers(target.value));
                        }}
                        ref={register({
                          required: true,
                          maxLength: 20,
                        })}
                        disabled={
                          ROLE_ADMIN || desbloqueado === false ? true : false
                        }
                      />
                      <p>(Somente números)</p>
                      {errors.totalDeEnfermeiros && (
                        <span className="errorField">Campo obrigatório.</span>
                      )}
                    </BoxInput>
                  </Col>
                </Row>
                {/*
                  *
                  ./ 10. Total de enfermeiros(as) que atuam na instituição:
                  *
                */}

                {/*
                  *
                  11. Total de técnicos(as) de enfermagem que atuam na instituição:
                  *
                */}
                <Row>
                  <Col span={12}>
                    <BoxInput style={{ paddingRight: '40px' }}>
                      <Label>
                        11. Total de técnicos(as) de enfermagem que atuam na
                        <br /> instituição:
                        <p> &nbsp;</p>
                      </Label>
                      <input
                        name="totalDeTecnicos"
                        type="text"
                        onChange={({ target }) => {
                          setTotalDeTecnicos(onlyNumbers(target.value));
                        }}
                        value={totalDeTecnicos}
                        ref={register({
                          required: true,
                          maxLength: 20,
                        })}
                        disabled={
                          ROLE_ADMIN || desbloqueado === false ? true : false
                        }
                      />
                      <p>(Somente números)</p>
                      {errors.totalDeTecnicos && (
                        <span className="errorField">Campo obrigatório.</span>
                      )}
                    </BoxInput>
                  </Col>
                  {/*
                  *
                  ./ 11. Total de técnicos(as) de enfermagem que atuam na instituição:
                  *
                */}

                  {/*
                  *
                  12. Total de funcionários(as) ativos(as) que atuam na instituição (considerar assistenciais e administrativos, exceto terceirizados):
                  *
                */}
                  <Col span={12}>
                    <BoxInput style={{ paddingLeft: '40px' }}>
                      <Label>
                        12. Total de funcionários(as) ativos(as) que atuam na
                        instituição (considerar assistenciais e administrativos,
                        exceto terceirizados):
                      </Label>
                      <input
                        name="totalDeEmpregados"
                        type="text"
                        value={totalDeEmpregados}
                        onChange={({ target }) => {
                          setTotalDeEmpregados(onlyNumbers(target.value));
                        }}
                        ref={register({
                          required: true,
                          maxLength: 20,
                          pattern: /^[0-9]+$/i,
                        })}
                        disabled={
                          ROLE_ADMIN || desbloqueado === false ? true : false
                        }
                      />
                      <p>(Somente números)</p>
                      {errors.totalDeEmpregados && (
                        <span className="errorField">Campo obrigatório.</span>
                      )}
                    </BoxInput>
                  </Col>
                </Row>
                {/*
                  *
                  ./ 12. Total de funcionários(as) ativos(as) que atuam na instituição (considerar assistenciais e administrativos, exceto terceirizados):
                  *
                */}

                {/*
                  *
                  13. A instituição acompanha a métrica Net Promoter Score (NPS)?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Label>
                        13. A instituição acompanha a métrica{' '}
                        <i>Net Promoter Score (NPS)?</i>
                      </Label>
                      <Row>
                        <Col span={8}>
                          <BoxRadios active={metricaNPS === true}>
                            <Radio
                              checked={metricaNPS === true}
                              onClick={() => setMetricaNPS(true)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={metricaNPS === false}>
                            <Radio
                              checked={metricaNPS === false}
                              onClick={() => {
                                setMetricaNPS(false);
                                setUltimaPontuacaoNPS(null);
                              }}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                        {metricaNPS && (
                          <Col span={8}>
                            <div className="boxUltimaPontuacaoNPS">
                              <span>Se sim, qual a nota no último ano?</span>
                              <input
                                value={ultimaPontuacaoNPS}
                                name="ultimaPontuacaoNPS"
                                min="0"
                                type="number"
                                onChange={e =>
                                  setUltimaPontuacaoNPS(e.target.value)
                                }
                                disabled={
                                  ROLE_ADMIN || desbloqueado === false
                                    ? true
                                    : false
                                }
                              />

                              <div className="ButtonTooltip">
                                <Tooltip title="O Net Promoter Score (NPS) é uma métrica de lealdade do cliente criada por Fred Heichheld em 2003, com o objetivo de medir o grau de lealdade dos clientes das empresas de qualquer segmento, trazendo reflexos da experiência e satisfação dos clientes. ">
                                  <span>?</span>
                                </Tooltip>
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </BoxInput>
                  </Col>
                </Row>
                {/*
                  *
                 ./ 13. A instituição acompanha a métrica Net Promoter Score (NPS)?
                  *
                */}

                {/*
                  *
                 .14. A instituição faz uso da metodologia Diagnosis Related Groups (DRGs)?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      14. A instituição faz uso da metodologia{' '}
                      <i>Diagnosis Related Groups (DRGs)</i>?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios active={usoDRG === true}>
                          <Radio
                            checked={usoDRG === true}
                            onClick={() => setUsoDRG(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios active={usoDRG === false}>
                          <Radio
                            checked={usoDRG === false}
                            onClick={() => setUsoDRG(false)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/*
                  *
                 ./ 14. A instituição faz uso da metodologia Diagnosis Related Groups (DRGs)?
                  *
                */}

                {/*
                  *
                   15. A instituição faz uso de protocolos institucionais?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      15. A instituição faz uso de protocolos institucionais?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios
                          active={usoProtocolosClinicosInstitucionais === true}
                        >
                          <Radio
                            checked={
                              usoProtocolosClinicosInstitucionais === true
                            }
                            onClick={() =>
                              setUsoProtocolosClinicosInstitucionais(true)
                            }
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios
                          active={usoProtocolosClinicosInstitucionais === false}
                        >
                          <Radio
                            checked={
                              usoProtocolosClinicosInstitucionais === false
                            }
                            onClick={() => {
                              setUsoProtocolosClinicosInstitucionais(false);
                              onChangeQualProtocoloClinicoInstitucional([]);
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>

                    {/* ProtocoloClinicoInst */}

                    {usoProtocolosClinicosInstitucionais && (
                      <Row>
                        <Col span={24}>
                          <BoxInput>
                            <div
                              className="boxUltimaPontuacaoNPS"
                              style={{ marginBottom: '10px' }}
                            >
                              <span>Se sim, quais?</span>

                              <p>&nbsp; (Marque todos que se aplicam)</p>
                            </div>

                            <BoxCheckboxs
                              qualProtocoloClinicoInstitucional={
                                qualProtocoloClinicoInstitucional
                              }
                            >
                              <Checkbox.Group
                                style={{ width: '100%' }}
                                onChange={
                                  onChangeQualProtocoloClinicoInstitucional
                                }
                                value={qualProtocoloClinicoInstitucional}
                                disabled={
                                  ROLE_ADMIN || desbloqueado === false
                                    ? true
                                    : false
                                }
                              >
                                <Row>
                                  {opcoesPerfilHospitalar &&
                                    opcoesPerfilHospitalar.map(
                                      ({ grupo, valor, nome, descricao }) => {
                                        const alignTxt =
                                          (String(nome).length < 25 && 26) ||
                                          (String(nome).length > 25 &&
                                            String(nome).length <= 26 &&
                                            20) ||
                                          (String(nome).length > 26 &&
                                            String(nome).length < 36 &&
                                            21) ||
                                          (String(nome).length >= 39 && 17) ||
                                          (String(nome).length >= 36 &&
                                            String(nome).length < 39 &&
                                            15);

                                        if (
                                          grupo ===
                                          'protocolos_clinicos_institucionais'
                                        ) {
                                          return (
                                            <Col span={8} key={valor}>
                                              <CheckboxBg
                                                selecionado={
                                                  !!qualProtocoloClinicoInstitucional.includes(
                                                    `${valor}`
                                                  )
                                                }
                                              >
                                                <Checkbox value={valor}>
                                                  <p
                                                    id={valor}
                                                    style={{
                                                      top: alignTxt,
                                                      position: 'absolute',
                                                      left: 22,
                                                      // padding: 10,
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {nome}
                                                  </p>
                                                </Checkbox>
                                                {/* <p>{nome}</p> */}
                                              </CheckboxBg>
                                            </Col>
                                          );
                                        }
                                      }
                                    )}
                                </Row>
                              </Checkbox.Group>
                            </BoxCheckboxs>
                          </BoxInput>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>

                {/*
                  *
                  ./ 15. A instituição faz uso de protocolos institucionais?
                  *
                */}

                {/*
                  *
                  16. A instituição faz uso de prontuário eletrônico ou sistema informatizado?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      16. A instituição faz uso de prontuário eletrônico ou
                      sistema informatizado?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios
                          active={usaProntuarioSistemaInformatizado === true}
                        >
                          <Radio
                            checked={usaProntuarioSistemaInformatizado === true}
                            onClick={() =>
                              setUsaProntuarioSistemaInformatizado(true)
                            }
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios
                          active={usaProntuarioSistemaInformatizado === false}
                        >
                          <Radio
                            checked={
                              usaProntuarioSistemaInformatizado === false
                            }
                            onClick={() => {
                              setUsaProntuarioSistemaInformatizado(false);
                              onChangeSistemaInformatizadoProntuario([]);
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>

                    {/* qual ProntuarioSistemaInformatizado */}
                    {usaProntuarioSistemaInformatizado && (
                      <Row>
                        <Col span={24}>
                          <BoxInput>
                            <div
                              className="boxUltimaPontuacaoNPS"
                              style={{ marginBottom: '10px' }}
                            >
                              <span>
                                Se sim, quais dos seguintes são informatizados?
                              </span>

                              <p>&nbsp; (Marque todos que se aplicam)</p>
                            </div>

                            <BoxCheckboxs>
                              <Checkbox.Group
                                style={{ width: '100%' }}
                                onChange={
                                  onChangeSistemaInformatizadoProntuario
                                }
                                value={sistemaInformatizadoProntuario}
                                disabled={
                                  ROLE_ADMIN || desbloqueado === false
                                    ? true
                                    : false
                                }
                              >
                                <Row>
                                  {opcoesPerfilHospitalar &&
                                    opcoesPerfilHospitalar.map(
                                      ({ grupo, valor, nome, descricao }) => {
                                        if (
                                          grupo ===
                                          'sistema_informatizado_protuario'
                                        ) {
                                          return (
                                            <Col span={12} key={valor}>
                                              <CheckboxBg
                                                selecionado={
                                                  !!sistemaInformatizadoProntuario.includes(
                                                    `${valor}`
                                                  )
                                                }
                                              >
                                                <Checkbox value={valor}>
                                                  <p
                                                    id={valor}
                                                    style={{
                                                      top: 20,
                                                      position: 'absolute',
                                                      left: 22,
                                                      // padding: 10,
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {nome}
                                                  </p>
                                                </Checkbox>
                                              </CheckboxBg>
                                            </Col>
                                          );
                                        }
                                      }
                                    )}
                                </Row>
                              </Checkbox.Group>
                            </BoxCheckboxs>
                          </BoxInput>
                          <Row>
                            <Col span={12}>
                              <BoxInput style={{ paddingRight: '40px' }}>
                                <div className="boxUltimaPontuacaoNPS">
                                  <Label>Informe quais sistemas eletrônicos o hospital utiliza. </Label>
                                </div>
                                <input
                                  name="sistemasEletronicosHospital"
                                  type="text"
                                  value={sistemasEletronicosHospital}
                                  onChange={({ target }) =>
                                    setSistemasEletronicosHospital(target.value)
                                  }
                                  disabled={
                                    ROLE_ADMIN || desbloqueado === false ? true : false
                                  }
                                />

                              </BoxInput>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                    )}
                  </Col>
                </Row>

                {/*
                  *
                  ./ 16. A instituição faz uso de prontuário eletrônico ou sistema informatizado?
                  *
                */}

                {/*
                  *
                  17. O hospital participa de algum programa de avaliação de qualidade por meio de indicadores?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      17. O hospital participa de algum programa de avaliação de
                      qualidade por meio de indicadores?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios
                          active={
                            usaProgramaAvaliacaoIndicadoresHospitalar === true
                          }
                        >
                          <Radio
                            checked={
                              usaProgramaAvaliacaoIndicadoresHospitalar === true
                            }
                            onClick={() =>
                              setUsaProgramaAvaliacaoIndicadoresHospitalar(true)
                            }
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios
                          active={
                            usaProgramaAvaliacaoIndicadoresHospitalar === false
                          }
                        >
                          <Radio
                            checked={
                              usaProgramaAvaliacaoIndicadoresHospitalar ===
                              false
                            }
                            onClick={() => {
                              setUsaProgramaAvaliacaoIndicadoresHospitalar(
                                false
                              );
                              onChangeSistemaInformatizadoAvaliacao([]);
                              setOutrosAval_IndicHospitalar(false);
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>

                    {/* qual ProntuarioSistemaInformatizado */}
                    {usaProgramaAvaliacaoIndicadoresHospitalar && (
                      <Row>
                        <Col span={24}>
                          <BoxInput>
                            <div
                              className="boxUltimaPontuacaoNPS"
                              style={{ marginBottom: '10px' }}
                            >
                              <span>Se sim, quais? </span>
                              <p>&nbsp; (Marque todas que se aplicam)</p>
                            </div>

                            <BoxCheckboxs>
                              <Checkbox.Group
                                style={{ width: '100%' }}
                                onChange={onChangeSistemaInformatizadoAvaliacao}
                                value={sistemaInformatizadoAvaliacao}
                                disabled={
                                  ROLE_ADMIN || desbloqueado === false
                                    ? true
                                    : false
                                }
                              >
                                <Row>
                                  {opcoesPerfilHospitalar &&
                                    opcoesPerfilHospitalar.map(
                                      ({
                                        grupo,
                                        valor,
                                        nome,
                                        descricao,
                                        nomeHtml,
                                      }) => {
                                        const alignTxt =
                                          String(nome).length > 41 ? 11 : 20;

                                        if (
                                          grupo ===
                                          'sistema_informatizado_avaliacao'
                                        ) {
                                          return (
                                            <Col span={8} key={valor}>
                                              <CheckboxBg
                                                selecionado={
                                                  !!sistemaInformatizadoAvaliacao.includes(
                                                    `${valor}`
                                                  )
                                                }
                                              >
                                                <Checkbox value={valor}>
                                                  <p
                                                    id={valor}
                                                    style={{
                                                      top: alignTxt,
                                                      position: 'absolute',
                                                      left: 22,
                                                      // padding: 10,
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={createInnerHtml(
                                                        nomeHtml
                                                      )}
                                                    />
                                                  </p>
                                                </Checkbox>
                                                {/* <p>{nome}</p> */}
                                              </CheckboxBg>
                                            </Col>
                                          );
                                        }
                                      }
                                    )}

                                  <Col
                                    span={8}
                                    key="outrosAvaliacaoIndicadoresHospitalar"
                                  >
                                    <CheckboxBg
                                      selecionado={!!outrosAval_IndicHospitalar}
                                    >
                                      <Checkbox
                                        onClick={() =>
                                          setOutrosAval_IndicHospitalar(
                                            !outrosAval_IndicHospitalar
                                          )
                                        }
                                        onChange={e =>
                                          setOutrosAvaliacaoIndicadoresHospitalar(
                                            !outrosAvaliacaoIndicadoresHospitalar
                                          )
                                        }
                                      >
                                        <p
                                          id="outrosAvaliacaoIndicadoresHospitalar"
                                          style={{
                                            top: 25,
                                            position: 'absolute',
                                            left: 22,
                                            fontWeight: 'bold',
                                          }}
                                        >
                                          Outro
                                        </p>
                                      </Checkbox>

                                      {/* {outrosAval_IndicHospitalar && (
                                        <input
                                          style={{
                                            marginTop: '10px',
                                          }}
                                          name="outrosAvaliacaoIndicadoresHospitalar"
                                          type="text"
                                          value={
                                            outrosAvaliacaoIndicadoresHospitalar
                                          }
                                          onChange={e =>
                                            setOutrosAvaliacaoIndicadoresHospitalar(
                                              e.target.value
                                            )
                                          }
                                          ref={register({
                                            required: sistemaInformatizadoAvaliacao.includes(
                                              'outrosAvaliacaoIndicadoresHospitalar'
                                            )
                                              ? true
                                              : false,
                                          })}
                                          disabled={
                                            ROLE_ADMIN || desbloqueado === false
                                              ? true
                                              : false
                                          }
                                        />
                                      )} */}
                                      {errors.outrosAvaliacaoIndicadoresHospitalar &&
                                        sistemaInformatizadoAvaliacao.includes(
                                          'outrosAvaliacaoIndicadoresHospitalar'
                                        ) && (
                                          <span className="errorField">
                                            Campo obrigatório.
                                          </span>
                                        )}
                                    </CheckboxBg>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </BoxCheckboxs>
                          </BoxInput>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
                {/*
                  *
                  ./ 17. O hospital participa de algum programa de avaliação de qualidade por meio de indicadores?
                  *
                */}

                {/*
                  *
                  18. A instituição é acreditada/certificada por algum programa?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      18. A instituição é acreditada/certificada por algum
                      programa? <span>(Marque todos que se aplicam)</span>
                    </Label>

                    <Row>
                      <Col span={8}>
                        <BoxRadios active={usaCertificadoPrograma === true}>
                          <Radio
                            checked={usaCertificadoPrograma === true}
                            onClick={() => setUsaCertificadoPrograma(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios active={usaCertificadoPrograma === false}>
                          <Radio
                            checked={usaCertificadoPrograma === false}
                            onClick={() => {
                              setUsaCertificadoPrograma(false);
                              onChangeCertificadoPrograma([]);
                              setOutrosCertif_Programa(false);
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>

                    {/* certificadoPrograma */}

                    {usaCertificadoPrograma && (
                      <Row>
                        <Col span={24}>
                          <BoxInput>
                            <div
                              className="boxUltimaPontuacaoNPS"
                              style={{ marginBottom: '10px' }}
                            >
                              <span>Se sim, quais?</span>
                            </div>

                            <BoxCheckboxs>
                              <Checkbox.Group
                                style={{ width: '100%' }}
                                onChange={onChangeCertificadoPrograma}
                                value={certificadoPrograma}
                                disabled={
                                  ROLE_ADMIN || desbloqueado === false
                                    ? true
                                    : false
                                }
                              >
                                <Row>
                                  {opcoesPerfilHospitalar &&
                                    opcoesPerfilHospitalar.map(
                                      ({ grupo, valor, nome, nomeHtml }) => {
                                        const alignTxt =
                                          String(nome).length > 44 ? 18 : 26;

                                        if (grupo === 'certificacao_programa') {
                                          return (
                                            <Col span={12} key={valor}>
                                              <CheckboxBg
                                                selecionado={
                                                  !!certificadoPrograma.includes(
                                                    `${valor}`
                                                  )
                                                }
                                              >
                                                <Checkbox value={valor}>
                                                  <p
                                                    id={valor}
                                                    style={{
                                                      top: alignTxt,
                                                      position: 'absolute',
                                                      left: 22,
                                                      // padding: 10,
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    <div
                                                      dangerouslySetInnerHTML={createInnerHtml(
                                                        nomeHtml
                                                      )}
                                                    />
                                                  </p>
                                                </Checkbox>
                                              </CheckboxBg>
                                            </Col>
                                          );
                                        }
                                      }
                                    )}

                                  <Col span={8} key="outrosCertificadoPrograma">
                                    <CheckboxBg
                                      selecionado={!!outrosCertif_Programa}
                                    >
                                      <Checkbox
                                        onClick={() =>
                                          setOutrosCertif_Programa(
                                            !outrosCertif_Programa
                                          )
                                        }
                                        onChange={e =>
                                          setOutrosCertificadoPrograma(
                                            !outrosCertificadoPrograma
                                          )
                                        }
                                      >
                                        <p
                                          id="outrosCertificadoPrograma"
                                          style={{
                                            top: 25,
                                            position: 'absolute',
                                            left: 22,
                                            fontWeight: 'bold',
                                          }}
                                        >
                                          Outro
                                        </p>
                                      </Checkbox>

                                      {errors.outrosCertificadoPrograma &&
                                        outrosCertif_Programa && (
                                          <span className="errorField">
                                            Campo obrigatório.
                                          </span>
                                        )}
                                    </CheckboxBg>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </BoxCheckboxs>
                          </BoxInput>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
                {/*
                  *
                  18. A instituição é acreditada/certificada por algum programa?
                  *
                */}

                {/*
                  *
                 19. A instituição faz busca ativa de pacientes para o monitoramento de indicadores?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      19. A instituição faz busca ativa de pacientes para o
                      monitoramento de indicadores?
                      <br />
                      <span>
                        (ex.: infecções, reinternações e complicações pós-alta)
                      </span>
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios active={monitoramentoDeIndicadores === true}>
                          <Radio
                            checked={monitoramentoDeIndicadores === true}
                            onClick={() => setMonitoramentoDeIndicadores(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios
                          active={monitoramentoDeIndicadores === false}
                        >
                          <Radio
                            checked={monitoramentoDeIndicadores === false}
                            onClick={() => setMonitoramentoDeIndicadores(false)}
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/*
                  *
                  ./ 19. A instituição faz busca ativa de pacientes para o monitoramento de indicadores?
                  *
                */}

                {/*
                  *
                     20. A instituição participa/coordena estudos clínicos?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      20. A instituição participa/coordena estudos clínicos?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios active={coordenaEstudosClinicos === true}>
                          <Radio
                            checked={coordenaEstudosClinicos === true}
                            onClick={() => setCoordenaEstudosClinicos(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios active={coordenaEstudosClinicos === false}>
                          <Radio
                            checked={coordenaEstudosClinicos === false}
                            onClick={() => setCoordenaEstudosClinicos(false)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/*
                  *
                   ./  20. A instituição participa/coordena estudos clínicos?
                  *
                */}
              </BoxForm>

              <hr />

              <BoxForm>
                <TitleSection>> Unidade de Emergência</TitleSection>


                {/*
                  *
                   21. Possui Unidade de Emergência?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>21. Possui Unidade de Emergência?</Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios active={possuiUnidadeDeEmergencia === true}>
                          <Radio
                            checked={possuiUnidadeDeEmergencia === true}
                            onClick={() => setPossuiUnidadeDeEmergencia(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios active={possuiUnidadeDeEmergencia === false}>
                          <Radio
                            checked={possuiUnidadeDeEmergencia === false}
                            onClick={() => {
                              setPossuiUnidadeDeEmergencia(false);
                              setAtendimentoEmergencia([]);
                              setPossuiEmergenciaEspecializada(false);
                              setEstratificacaoDeRiscoNaEmergencia(false);
                              setAtendeEmergenciaAdulto(false);
                              setAtendeEmergenciaPediatrico(false);
                              setPossuiAtendimentoEmergencia(false);
                              onChangeEmergenciaEspecializada([]);
                              setOutrosEmerg_Especializada(null);
                              setOutrosEmergenciaEspecializada('');
                              onChangeEstratificacoesDeRisco([]);
                              setEstratificacaoRiscoAtsTipo('');
                              setOutrosEstratificacoesDeRisco('');
                              setEstratificacaoRiscoCtasTipo('');
                              setEstratificacaoRiscoMtsTipo('');
                              setEstratificacaoRiscoEsiTipo('');
                              setOutrosEstratif_DeRisco(null);
                              setOutrosEstratificacoesDeRisco('');
                              setTotalDeLietosEmergencia(onlyNumbers('0'));
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/*
                  *
                  ./  21. Possui Unidade de Emergência?
                  *
                */}

                {/*
                  *
                   22. Atendimento da emergência
                  *
                */}
                {possuiUnidadeDeEmergencia ? (
                  <Row>
                    <Col span={24}>
                      <Label>22. Atendimento da emergência </Label>
                      <Row>
                        {opcoesPerfilHospitalar &&
                          opcoesPerfilHospitalar.map(
                            ({ grupo, valor, nome, descricao }) => {
                              if (grupo === 'atendimento_emergencia') {
                                return (
                                  <Col span={8}>
                                    <BoxRadios
                                      active={
                                        atendimentoEmergencia?.[0] === valor
                                      }
                                    >
                                      <Radio
                                        checked={
                                          atendimentoEmergencia?.[0] === valor
                                        }
                                        onClick={() => {
                                          setAtendimentoEmergencia([valor]);
                                          setPossuiAtendimentoEmergencia(true);
                                        }}
                                        disabled={
                                          ROLE_ADMIN || desbloqueado === false
                                            ? true
                                            : false
                                        }
                                      >
                                        {nome}
                                      </Radio>
                                    </BoxRadios>
                                  </Col>
                                );
                              }
                            }
                          )}
                      </Row>
                    </Col>
                  </Row>
                ) : (<br />

                )}
                {/*
                  *
                   ./ 22. Atendimento da emergência
                  *
                */}

                {/*
                  *
                   23. Possui emergência especializada?
                  *
                */
                }
                
                {possuiUnidadeDeEmergencia && possuiAtendimentoEmergencia ? (
                  <Row>
                    <Col span={24}>
                      <Label>23. Possui emergência especializada? </Label>
                      <Row>
                        <Col span={8}>
                          <BoxRadios
                            active={possuiEmergenciaEspecializada === true}
                          >
                            <Radio
                              checked={possuiEmergenciaEspecializada === true}
                              onClick={() =>
                                setPossuiEmergenciaEspecializada(true)
                              }
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios
                            active={possuiEmergenciaEspecializada === false}
                          >
                            <Radio
                              checked={possuiEmergenciaEspecializada === false}
                              onClick={() => {
                                setPossuiEmergenciaEspecializada(false);
                                onChangeEmergenciaEspecializada([]);
                                setOutrosEmerg_Especializada(null);
                                setOutrosEmergenciaEspecializada('');
                              }}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>

                      {/* Possui emergência especializada?  */}
                      {possuiEmergenciaEspecializada && (
                        <Row>
                          <Col span={24}>
                            <BoxInput>
                              <div
                                className="boxUltimaPontuacaoNPS"
                                style={{ marginBottom: '10px' }}
                              >
                                <span>Se sim, quais? </span>
                                <p> (Marque todas que se aplicam)</p>
                              </div>

                              <BoxCheckboxs>
                                <Checkbox.Group
                                  style={{ width: '100%' }}
                                  onChange={onChangeEmergenciaEspecializada}
                                  value={emergenciaEspecializada}
                                  disabled={
                                    ROLE_ADMIN || desbloqueado === false
                                      ? true
                                      : false
                                  }
                                >
                                  <Row>
                                    {opcoesPerfilHospitalar &&
                                      opcoesPerfilHospitalar.map(
                                        ({ grupo, valor, nome, descricao }) => {
                                          const alignTxt =
                                            (String(nome).length < 23 && 26) ||
                                            (String(nome).length >= 23 && 20);
                                          if (
                                            grupo === 'emergencia_especializada'
                                          ) {
                                            return (
                                              <Col span={8} key={valor}>
                                                <CheckboxBg
                                                  selecionado={
                                                    !!emergenciaEspecializada.includes(
                                                      `${valor}`
                                                    )
                                                  }
                                                >
                                                  <Checkbox value={valor}>
                                                    <p
                                                      id={valor}
                                                      style={{
                                                        top: alignTxt,
                                                        position: 'absolute',
                                                        left: 22,
                                                        fontWeight: 'bold',
                                                      }}
                                                    >
                                                      {nome}
                                                    </p>
                                                  </Checkbox>
                                                </CheckboxBg>
                                              </Col>
                                            );
                                          }
                                        }
                                      )}
                                    <Col
                                      span={8}
                                      key="outrosEmergenciaEspecializada"
                                    >
                                      <CheckboxBg
                                        selecionado={!!outrosEmerg_Especializada}
                                      >
                                        <Checkbox
                                          name="outrosEmerg_Especializada"
                                          checked={outrosEmerg_Especializada}
                                          onClick={() =>
                                            setOutrosEmerg_Especializada(
                                              !outrosEmerg_Especializada
                                            )
                                          }
                                          onChange={e =>
                                            setOutrosEmergenciaEspecializada(
                                              !outrosEmergenciaEspecializada
                                            )
                                          }
                                        >
                                          <p
                                            id="outrosEmergenciaEspecializada"
                                            style={{
                                              top: 25,
                                              position: 'absolute',
                                              left: 22,
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            Outro
                                          </p>
                                        </Checkbox>

                                        {errors.outrosEmergenciaEspecializada &&
                                          outrosEmerg_Especializada && (
                                            <span className="errorField">
                                              Campo obrigatório.
                                            </span>
                                          )}
                                      </CheckboxBg>
                                    </Col>
                                  </Row>
                                </Checkbox.Group>
                              </BoxCheckboxs>
                            </BoxInput>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                ) : (<br />

                )}
                {/*
                  *
                   23. Possui emergência especializada?
                  *
                */}

                {/*
                  *
                   24. Utiliza protocolo de estratificação de risco na emergência?
                  *
                */
                }
                {possuiUnidadeDeEmergencia && possuiAtendimentoEmergencia ? (
                  <Row>
                    <Col span={24}>
                      <Label>
                        24. Utiliza protocolo de estratificação de risco na
                        emergência?
                      </Label>
                      <Row>
                        <Col span={8}>
                          <BoxRadios
                            active={estratificacaoDeRiscoNaEmergencia === true}
                          >
                            <Radio
                              checked={estratificacaoDeRiscoNaEmergencia === true}
                              onClick={() =>
                                setEstratificacaoDeRiscoNaEmergencia(true)
                              }
                              disabled={ROLE_ADMIN || !desbloqueado}
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios
                            active={estratificacaoDeRiscoNaEmergencia === false}
                          >
                            <Radio
                              checked={
                                estratificacaoDeRiscoNaEmergencia === false
                              }
                              onClick={() => {
                                setEstratificacaoDeRiscoNaEmergencia(false);
                                onChangeEstratificacoesDeRisco([]);
                                setEstratificacaoRiscoAtsTipo('');
                                setOutrosEstratificacoesDeRisco('');
                                setEstratificacaoRiscoCtasTipo('');
                                setEstratificacaoRiscoMtsTipo('');
                                setEstratificacaoRiscoEsiTipo('');
                                setOutrosEstratif_DeRisco(null);
                                setOutrosEstratificacoesDeRisco('');
                              }}
                              disabled={ROLE_ADMIN || !desbloqueado}
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>

                      {/* Possui emergência especializada?  */}
                      {estratificacaoDeRiscoNaEmergencia && (
                        <Row>
                          <Col span={24}>
                            <BoxInput>
                              <div
                                className="boxUltimaPontuacaoNPS"
                                style={{ marginBottom: '10px' }}
                              >
                                <span>Se sim, quais? </span>

                                <p>&nbsp; (Marque todas que se aplicam)</p>
                              </div>

                              <BoxCheckboxs>
                                <Checkbox.Group
                                  style={{ width: '100%' }}
                                  onChange={onChangeEstratificacoesDeRisco}
                                  value={estratificacoesDeRisco}
                                  disabled={ROLE_ADMIN || !desbloqueado}
                                >
                                  <Row>
                                    {opcoesPerfilHospitalar?.map(
                                        ({
                                          grupo,
                                          valor,
                                          nome,
                                          descricao,
                                          nomeHtml,
                                        }) => {
                                          const alignTxt =
                                            String(nome).length > 37 ? 11 : 20;

                                          if (grupo === 'estratificacao_risco') {
                                            return (
                                              <Col span={8} key={valor}>
                                                <CheckboxBg
                                                  selecionado={
                                                    !!estratificacoesDeRisco.includes(
                                                      `${valor}`
                                                    )
                                                  }
                                                >
                                                  <Checkbox value={valor}>
                                                    <p
                                                      id={valor}
                                                      style={{
                                                        top: alignTxt,
                                                        position: 'absolute',
                                                        left: 22,
                                                        fontWeight: 'bold',
                                                      }}
                                                    >
                                                      <div
                                                        dangerouslySetInnerHTML={createInnerHtml(
                                                          nomeHtml
                                                        )}
                                                      />
                                                    </p>
                                                  </Checkbox>

                                                  {/*
                                                 *
                                                 *  Opcoes: Original / Adaptado
                                                 *
                                                 */}

                                                  {valor ===
                                                    'estratificacao_risco_ats' &&
                                                    estratificacoesDeRisco.includes(
                                                      'estratificacao_risco_ats'
                                                    ) && (
                                                      <div className="diagnotico_terapeutico_hemodinamica">
                                                        <br />
                                                        <BoxInput>
                                                          <Row
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoAtsTipo ===
                                                                    'o'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoAtsTipo(
                                                                      'o'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Original
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>

                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoAtsTipo ===
                                                                    'a'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoAtsTipo(
                                                                      'a'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Adaptado
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>
                                                          </Row>
                                                        </BoxInput>
                                                      </div>
                                                    )}

                                                  {valor ===
                                                    'estratificacao_risco_ctas' &&
                                                    estratificacoesDeRisco.includes(
                                                      'estratificacao_risco_ctas'
                                                    ) && (
                                                      <div className="diagnotico_terapeutico_hemodinamica">
                                                        <br />
                                                        <BoxInput>
                                                          <Row
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoCtasTipo ===
                                                                    'o'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoCtasTipo(
                                                                      'o'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Original
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>

                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoCtasTipo ===
                                                                    'a'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoCtasTipo(
                                                                      'a'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Adaptado
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>
                                                          </Row>
                                                        </BoxInput>
                                                      </div>
                                                    )}

                                                  {valor ===
                                                    'estratificacao_risco_mts' &&
                                                    estratificacoesDeRisco.includes(
                                                      'estratificacao_risco_mts'
                                                    ) && (
                                                      <div className="diagnotico_terapeutico_hemodinamica">
                                                        <br />
                                                        <BoxInput>
                                                          <Row
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoMtsTipo ===
                                                                    'o'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoMtsTipo(
                                                                      'o'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Original
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>

                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoMtsTipo ===
                                                                    'a'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoMtsTipo(
                                                                      'a'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Adaptado
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>
                                                          </Row>
                                                        </BoxInput>
                                                      </div>
                                                    )}

                                                  {valor ===
                                                    'estratificacao_risco_esi' &&
                                                    estratificacoesDeRisco.includes(
                                                      'estratificacao_risco_esi'
                                                    ) && (
                                                      <div className="diagnotico_terapeutico_hemodinamica">
                                                        <br />
                                                        <BoxInput>
                                                          <Row
                                                            style={{
                                                              marginBottom: 0,
                                                            }}
                                                          >
                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoEsiTipo ===
                                                                    'o'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoEsiTipo(
                                                                      'o'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Original
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>

                                                            <Col span={12}>
                                                              <BoxRadios
                                                                style={{
                                                                  padding:
                                                                    '10px 5px',
                                                                }}
                                                              >
                                                                <Radio
                                                                  checked={
                                                                    estratificacaoRiscoEsiTipo ===
                                                                    'a'
                                                                  }
                                                                  onClick={() =>
                                                                    setEstratificacaoRiscoEsiTipo(
                                                                      'a'
                                                                    )
                                                                  }
                                                                  disabled={ROLE_ADMIN || !desbloqueado}
                                                                >
                                                                  Adaptado
                                                                </Radio>
                                                              </BoxRadios>
                                                            </Col>
                                                          </Row>
                                                        </BoxInput>
                                                      </div>
                                                    )}

                                                  {/*
                                                 *
                                                 *  ./ Opcoes: Original / Adaptado
                                                 *
                                                 */}
                                                </CheckboxBg>
                                              </Col>
                                            );
                                          }
                                        }
                                      )}

                                    <Col
                                      span={8}
                                      key="outrosEstratificacoesDeRisco"
                                    >
                                      <CheckboxBg
                                        selecionado={!!outrosEstratif_DeRisco}
                                      >
                                        <Checkbox
                                          onClick={() =>
                                            setOutrosEstratif_DeRisco(
                                              !outrosEstratif_DeRisco
                                            )
                                          }
                                          onChange={e =>
                                            setOutrosEstratificacoesDeRisco(
                                              !outrosEstratificacoesDeRisco
                                            )
                                          }
                                        >
                                          <p
                                            id="outrosEstratificacoesDeRisco"
                                            style={{
                                              top: 25,
                                              position: 'absolute',
                                              left: 22,
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            Outro
                                          </p>
                                        </Checkbox>

                                        {errors.outrosEstratificacoesDeRisco &&
                                          outrosEstratif_DeRisco && (
                                            <span className="errorField">
                                              Campo obrigatório.
                                            </span>
                                          )}
                                      </CheckboxBg>
                                    </Col>
                                  </Row>
                                </Checkbox.Group>
                              </BoxCheckboxs>
                            </BoxInput>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                ) : (<br />

                )}
                {/*
                  *
                  ./  24. Utiliza protocolo de estratificação de risco na emergência?
                  *
                */}

                {/*
                  *
                   25. Atende pacientes adultos na emergência?
                  *
                */}
                {possuiUnidadeDeEmergencia && possuiAtendimentoEmergencia ? (
                  <Row>
                    <Col span={24}>
                      <Label> 25. Atende pacientes adultos na emergência? </Label>
                      <Row>
                        <Col span={8}>
                          <BoxRadios active={atendeEmergenciaAdulto === true}>
                            <Radio
                              checked={atendeEmergenciaAdulto === true}
                              onClick={() => setAtendeEmergenciaAdulto(true)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios active={atendeEmergenciaAdulto === false}>
                            <Radio
                              checked={atendeEmergenciaAdulto === false}
                              onClick={() => setAtendeEmergenciaAdulto(false)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (<br />

                )}
                {/*
                  *
                   ./ 25. Atende pacientes adultos na emergência?
                  *
                */}

                {/*
                  *
                   26. Atende pacientes pediátricos na emergência?
                  *
                */}
                {possuiUnidadeDeEmergencia && possuiAtendimentoEmergencia ? (
                  <Row>
                    <Col span={24}>
                      <Label>
                        26. Atende pacientes pediátricos na emergência?
                      </Label>
                      <Row>
                        <Col span={8}>
                          <BoxRadios active={atendeEmergenciaPediatrico === true}>
                            <Radio
                              checked={atendeEmergenciaPediatrico === true}
                              onClick={() => setAtendeEmergenciaPediatrico(true)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Sim
                            </Radio>
                          </BoxRadios>
                        </Col>

                        <Col span={8}>
                          <BoxRadios
                            active={atendeEmergenciaPediatrico === false}
                          >
                            <Radio
                              checked={atendeEmergenciaPediatrico === false}
                              onClick={() => setAtendeEmergenciaPediatrico(false)}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              Não
                            </Radio>
                          </BoxRadios>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (<br />

                )}
                {/*
                  *
                   ./ 26. Atende pacientes pediátricos na emergência?
                  *
                */}

                {/*
                  *
                   27. Total de leitos na(s) emergência(s):
                  *
                */}
                {possuiUnidadeDeEmergencia && possuiAtendimentoEmergencia ? (
                  <Row>
                    <Col span={12}>
                      <BoxInput style={{ paddingRight: '40px' }}>
                        <Label>27. Total de leitos na(s) emergência(s): </Label>
                        <input
                          name="totalDeLietosEmergencia"
                          type="text"
                          value={totalDeLietosEmergencia}
                          onChange={({ target }) =>
                            setTotalDeLietosEmergencia(onlyNumbers(target.value))
                          }
                          ref={register({
                            maxLength: 20,
                          })}
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                        />
                        <p>(Somente números)</p>
                        {errors.totalDeLietosEmergencia && (
                          <span className="errorField">Campo obrigatório.</span>
                        )}
                      </BoxInput>
                    </Col>
                  </Row>
                ) : (<br />

                )}
                {/*
                  *
                   ./ 27. Total de leitos na(s) emergência(s):
                  *
                */}
              </BoxForm>

              <hr />

              <BoxForm>
                <TitleSection>> Outros Serviços/Unidades</TitleSection>

                {/*
                  *
                  28. Possui Time de Resposta Rápida (TRR) ou equivalente?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      28. Possui Time de Resposta Rápida (TRR) ou equivalente?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios active={timeDeRespostaRapida === true}>
                          <Radio
                            checked={timeDeRespostaRapida === true}
                            onClick={() => setTimeDeRespostaRapida(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios active={timeDeRespostaRapida === false}>
                          <Radio
                            checked={timeDeRespostaRapida === false}
                            onClick={() => setTimeDeRespostaRapida(false)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/*
                  *
                  ./ 28. Possui Time de Resposta Rápida (TRR) ou equivalente?
                  *
                */}

                {/*
                  *
                   29. Unidades presentes na Instituição:
                  *
                */}

                <Row>
                  <Label>29. Unidades presentes na Instituição:</Label>
                  <Col span={24}>
                    <Col span={12}>
                      <CheckboxBg selecionado={possuiUnidadeCoronariana}>
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeCoronariana}
                          onChange={e => {
                            setPossuiUnidadeCoronariana(
                              !possuiUnidadeCoronariana
                            );
                          }}
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                        >
                          Unidade Coronariana
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg
                        selecionado={possuiUnidadeInternacaoCirurgica}
                      >
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeInternacaoCirurgica}
                          onChange={e => {
                            setPossuiUnidadeInternacaoCirurgica(
                              !possuiUnidadeInternacaoCirurgica
                            );
                          }}
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                        >
                          Unidade de Internação - Cirúrgica
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg
                        selecionado={possuiUnidadeInternacaoClinicaMedica}
                      >
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeInternacaoClinicaMedica}
                          onChange={e => {
                            setPossuiUnidadeInternacaoClinicaMedica(
                              !possuiUnidadeInternacaoClinicaMedica
                            );
                          }}
                        >
                          Unidade de Internação - Clínica médica
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg
                        selecionado={possuiUnidadeInternacaoObstetricaNeonatal}
                      >
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeInternacaoObstetricaNeonatal}
                          onChange={e => {
                            setPossuiUnidadeInternacaoObstetricaNeonatal(
                              !possuiUnidadeInternacaoObstetricaNeonatal
                            );
                          }}
                        >
                          Unidade de Internação - Obstétrica e Neonatal
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg
                        selecionado={possuiUnidadeInternacaoPediatrica}
                      >
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeInternacaoPediatrica}
                          onChange={e => {
                            setPossuiUnidadeInternacaoPediatrica(
                              !possuiUnidadeInternacaoPediatrica
                            );
                          }}
                        >
                          Unidade de Internação - Pediatrica
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg
                        selecionado={possuiUnidadeInternacaoTraumatoOrtopedica}
                      >
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeInternacaoTraumatoOrtopedica}
                          onChange={e => {
                            setPossuiUnidadeInternacaoTraumatoOrtopedica(
                              !possuiUnidadeInternacaoTraumatoOrtopedica
                            );
                          }}
                        >
                          Unidade de Internação - Traumato-ortopédica
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    {/*
                      ./ A instituição possui Unidade de AVC?
                    */}
                    <Col span={12}>
                      <CheckboxBg selecionado={possuiUnidadeAVC}>
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUnidadeAVC}
                          onChange={({ target }) => {
                            setPossuiUnidadeAVC(!possuiUnidadeAVC);

                            if (!target?.checked) {
                              setTerapiaFibrinolitica(null);
                              setTrombectomia(null);
                            }
                          }}
                        >
                          Unidade de AVC/Vascular
                        </Checkbox>
                      </CheckboxBg>
                      {possuiUnidadeAVC && (
                        <Row>
                          <Col span={24}>
                            <BoxInput>
                              <Label>
                                Realiza terapia fibrinolítica (ex.: trombólise)?{' '}
                              </Label>

                              <Row>
                                <Col>
                                  <BoxRadios active={terapiaFibrinolitica}>
                                    <Radio
                                      checked={terapiaFibrinolitica}
                                      onClick={() =>
                                        setTerapiaFibrinolitica(true)
                                      }
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                    >
                                      Sim
                                    </Radio>
                                  </BoxRadios>

                                  <BoxRadios
                                    active={terapiaFibrinolitica === false}
                                  >
                                    <Radio
                                      checked={terapiaFibrinolitica === false}
                                      onClick={() =>
                                        setTerapiaFibrinolitica(false)
                                      }
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                    >
                                      Não
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              </Row>
                            </BoxInput>

                            <BoxInput>
                              <Label>Realiza trombectomia?</Label>

                              <Row>
                                <Col>
                                  <BoxRadios active={trombectomia}>
                                    <Radio
                                      checked={trombectomia}
                                      onClick={() => setTrombectomia(true)}
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                    >
                                      Sim
                                    </Radio>
                                  </BoxRadios>
                                  <BoxRadios active={trombectomia === false}>
                                    <Radio
                                      checked={trombectomia === false}
                                      onClick={() => setTrombectomia(false)}
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                    >
                                      Não
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              </Row>
                            </BoxInput>
                          </Col>
                        </Row>
                      )}
                    </Col>

                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg selecionado={unidadeSemiIntensiva}>
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={unidadeSemiIntensiva}
                          onChange={e => {
                            setUnidadeSemiIntensiva(!unidadeSemiIntensiva);
                          }}
                        >
                          Unidade intermediária/semi-intensiva
                        </Checkbox>
                      </CheckboxBg>
                    </Col>

                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg selecionado={possuiBlocoCirurgico}>
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiBlocoCirurgico}
                          onChange={({ target }) => {
                            setPossuiBlocoCirurgico(!possuiBlocoCirurgico);

                            if (!target?.checked) {
                              setQuantasSalasDeCirurgia(null);
                            }
                          }}
                        >
                          Bloco Cirúrgico
                        </Checkbox>
                      </CheckboxBg>

                      {possuiBlocoCirurgico && (
                        <div style={{ padding: '0 20px' }}>
                          <BoxInput>
                            <Label>Quantas salas de cirurgia? </Label>
                            <input
                              name="quantasSalasDeCirurgia"
                              type="text"
                              value={quantasSalasDeCirurgia}
                              onChange={({ target }) =>
                                setQuantasSalasDeCirurgia(
                                  onlyNumbers(target.value)
                                )
                              }
                              ref={register({
                                required: possuiBlocoCirurgico ? true : false,
                                maxLength: 20,
                              })}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            />
                            <p>(Somente números)</p>
                            {errors.quantasSalasDeCirurgia && (
                              <span className="errorField">
                                Campo obrigatório.
                              </span>
                            )}
                          </BoxInput>
                        </div>
                      )}
                    </Col>

                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg selecionado={possuiCentroObstestrico}>
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiCentroObstestrico}
                          onChange={({ target }) => {
                            setPossuiCentroObstestrico(
                              !possuiCentroObstestrico
                            );
                            if (!target?.checked) {
                              setQuantasSalasDeParto(null);
                            }
                          }}
                        >
                          Centro Obstétrico
                        </Checkbox>
                      </CheckboxBg>

                      {possuiCentroObstestrico && (
                        <div style={{ padding: '0 20px' }}>
                          <BoxInput>
                            <Label>Quantas salas de parto? </Label>
                            <input
                              name="quantasSalasDeParto"
                              type="text"
                              value={quantasSalasDeParto}
                              onChange={({ target }) =>
                                setQuantasSalasDeParto(
                                  onlyNumbers(target.value)
                                )
                              }
                              ref={register({
                                required: possuiCentroObstestrico
                                  ? true
                                  : false,
                                maxLength: 20,
                              })}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            />
                            <p>(Somente números)</p>
                            {errors.quantasSalasDeParto && (
                              <span className="errorField">
                                Campo obrigatório.
                              </span>
                            )}
                          </BoxInput>
                        </div>
                      )}
                    </Col>

                    {/* --- */}

                    <Col span={12}>
                      <CheckboxBg selecionado={possuiUTI}>
                        <Checkbox
                          disabled={
                            ROLE_ADMIN || desbloqueado === false ? true : false
                          }
                          checked={possuiUTI}
                          onChange={e => {
                            setPossuiUTI(!possuiUTI);
                          }}
                        >
                          Unidade de Tratamento Intensivo Geral
                        </Checkbox>
                      </CheckboxBg>
                    </Col>
                    {/* --- */}

                    <Col span={24}>
                      <Row>
                        <Col span={12}>
                          <CheckboxBg
                            selecionado={
                              possuiUnidadeTratamentoIntensivoEspecializada
                            }
                          >
                            <Checkbox
                              checked={
                                possuiUnidadeTratamentoIntensivoEspecializada
                              }
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                              onChange={({ target }) => {
                                setPossuiUnidadeTratamentoIntensivoEspecializada(
                                  !possuiUnidadeTratamentoIntensivoEspecializada
                                );

                                if (!target?.checked) {
                                  onChangeUtiEspecializada([]);
                                  // reset neonatal
                                  setAtendeNeonatal(null);
                                  setTotalLeitoUTINeonatal(null);
                                  setTotalEnfermeirosUTINeonatal(null);

                                  // reset pediadrico
                                  setAtendePediatrico(null);
                                  setTotalLeitoUTIPediatrico(null);
                                  setTotalEnfermeirosUTIPediatrico(null);

                                  // reset adulto
                                  setAtendeAdulto(null);
                                  setTotalLeitoUTIAdulto(null);
                                  setTotalEnfermeirosUTIAdulto(null);
                                }
                              }}
                            >
                              Unidade de Tratamento Intensivo Especializada
                            </Checkbox>
                          </CheckboxBg>
                        </Col>
                      </Row>

                      {possuiUnidadeTratamentoIntensivoEspecializada && (
                        <Row>
                          <Col span={24}>
                            <BoxInput>
                              <div
                                className="boxQuestion"
                                style={{ margin: '0 0 10px 10px' }}
                              >
                                <span>Quais especialidades?</span>
                              </div>

                              <BoxCheckboxs>
                                <Checkbox.Group
                                  style={{ width: '100%' }}
                                  onChange={onChangeUtiEspecializada}
                                  value={utiEspecializada}
                                  disabled={
                                    ROLE_ADMIN || desbloqueado === false
                                      ? true
                                      : false
                                  }
                                >
                                  <Row>
                                    {opcoesPerfilHospitalar &&
                                      opcoesPerfilHospitalar.map(
                                        ({
                                          grupo,
                                          valor,
                                          nome,
                                          descricao,
                                          nomeHtml,
                                        }) => {
                                          const alignTxt =
                                            String(nome).length > 37 ? 11 : 20;

                                          if (grupo === 'uti_especializada') {
                                            return (
                                              <Col span={8} key={valor}>
                                                <CheckboxBg
                                                  selecionado={
                                                    !!utiEspecializada.includes(
                                                      `${valor}`
                                                    )
                                                  }
                                                >
                                                  <Checkbox value={valor}>
                                                    <p
                                                      id={valor}
                                                      style={{
                                                        top: alignTxt,
                                                        position: 'absolute',
                                                        left: 22,

                                                        fontWeight: 'bold',
                                                      }}
                                                    >
                                                      <div
                                                        dangerouslySetInnerHTML={createInnerHtml(
                                                          nomeHtml
                                                        )}
                                                      />
                                                    </p>
                                                  </Checkbox>
                                                </CheckboxBg>
                                              </Col>
                                            );
                                          }
                                        }
                                      )}
                                  </Row>
                                </Checkbox.Group>
                              </BoxCheckboxs>
                            </BoxInput>
                            {/* / */}

                            <BoxInput>
                              <div
                                className="boxQuestion"
                                style={{ margin: '0 0 10px 10px' }}
                              >
                                <span>
                                  Qual o grupo etário dos pacientes atendidos?
                                </span>
                              </div>

                              {/* Neonatal */}
                              <Row style={{ marginBottom: 0 }}>
                                <Col span={12}>
                                  <CheckboxBg selecionado={atendeNeonatal}>
                                    <Checkbox
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                      checked={atendeNeonatal}
                                      onChange={({ target }) => {
                                        setAtendeNeonatal(!atendeNeonatal);
                                        if (!target?.checked) {
                                          setTotalLeitoUTINeonatal(null);
                                          setTotalEnfermeirosUTINeonatal(null);
                                        }
                                      }}
                                    >
                                      Neonatal
                                    </Checkbox>
                                  </CheckboxBg>
                                  {atendeNeonatal && (
                                    <Row>
                                      <Col span={24}>
                                        <div style={{ padding: '20px' }}>
                                          <BoxInput>
                                            <Label>Quanto leitos? </Label>
                                            <input
                                              name="totalLeitoUTINeonatal"
                                              type="text"
                                              value={totalLeitoUTINeonatal}
                                              onChange={({ target }) =>
                                                setTotalLeitoUTINeonatal(
                                                  onlyNumbers(target.value)
                                                )
                                              }
                                              ref={register({
                                                required: atendePediatrico
                                                  ? true
                                                  : false,
                                                maxLength: 20,
                                              })}
                                              disabled={
                                                ROLE_ADMIN ||
                                                  desbloqueado === false
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <p>(Somente números)</p>
                                            {errors.totalLeitoUTINeonatal && (
                                              <span className="errorField">
                                                Campo obrigatório.
                                              </span>
                                            )}
                                          </BoxInput>

                                          <br />

                                          <BoxInput>
                                            <Label>
                                              Quantos enfermeiros(as) nesta UTI?
                                            </Label>
                                            <input
                                              name="totalEnfermeirosUTINeonatal"
                                              type="text"
                                              value={
                                                totalEnfermeirosUTINeonatal
                                              }
                                              onChange={({ target }) =>
                                                setTotalEnfermeirosUTINeonatal(
                                                  onlyNumbers(target.value)
                                                )
                                              }
                                              ref={register({
                                                required: atendeNeonatal
                                                  ? true
                                                  : false,
                                                maxLength: 20,
                                              })}
                                              disabled={
                                                ROLE_ADMIN ||
                                                  desbloqueado === false
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <p>(Somente números)</p>
                                            {errors.totalEnfermeirosUTINeonatal && (
                                              <span className="errorField">
                                                Campo obrigatório.
                                              </span>
                                            )}
                                          </BoxInput>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                              {/* ./Neonatal */}

                              {/*Pediátrico */}
                              <Row style={{ marginBottom: 0 }}>
                                <Col span={12}>
                                  <CheckboxBg selecionado={atendePediatrico}>
                                    <Checkbox
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                      checked={atendePediatrico}
                                      onChange={({ target }) => {
                                        setAtendePediatrico(!atendePediatrico);

                                        if (!target?.checked) {
                                          setTotalLeitoUTIPediatrico(null);
                                          setTotalEnfermeirosUTIPediatrico(
                                            null
                                          );
                                        }
                                      }}
                                    >
                                      Pediátrico
                                    </Checkbox>
                                  </CheckboxBg>
                                  {atendePediatrico && (
                                    <Row>
                                      <Col span={24}>
                                        <div style={{ padding: '20px' }}>
                                          <BoxInput>
                                            <Label>Quanto leitos? </Label>
                                            <input
                                              name="totalLeitoUTIPediatrico"
                                              type="text"
                                              value={totalLeitoUTIPediatrico}
                                              onChange={({ target }) =>
                                                setTotalLeitoUTIPediatrico(
                                                  onlyNumbers(target.value)
                                                )
                                              }
                                              ref={register({
                                                required: atendePediatrico
                                                  ? true
                                                  : false,
                                                maxLength: 20,
                                              })}
                                              disabled={
                                                ROLE_ADMIN ||
                                                  desbloqueado === false
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <p>(Somente números)</p>
                                            {errors.totalLeitoUTIPediatrico && (
                                              <span className="errorField">
                                                Campo obrigatório.
                                              </span>
                                            )}
                                          </BoxInput>

                                          <br />

                                          <BoxInput>
                                            <Label>
                                              Quantos enfermeiros(as) nesta UTI?
                                            </Label>
                                            <input
                                              name="totalEnfermeirosUTIPediatrico"
                                              type="text"
                                              value={
                                                totalEnfermeirosUTIPediatrico
                                              }
                                              onChange={({ target }) =>
                                                setTotalEnfermeirosUTIPediatrico(
                                                  onlyNumbers(target.value)
                                                )
                                              }
                                              ref={register({
                                                required: atendePediatrico
                                                  ? true
                                                  : false,
                                                maxLength: 20,
                                              })}
                                              disabled={
                                                ROLE_ADMIN ||
                                                  desbloqueado === false
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <p>(Somente números)</p>
                                            {errors.totalEnfermeirosUTIPediatrico && (
                                              <span className="errorField">
                                                Campo obrigatório.
                                              </span>
                                            )}
                                          </BoxInput>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                              {/* ./Pediátrico */}

                              {/*Adulto */}
                              <Row style={{ marginBottom: 0 }}>
                                <Col span={12}>
                                  <CheckboxBg selecionado={atendeAdulto}>
                                    <Checkbox
                                      disabled={
                                        ROLE_ADMIN || desbloqueado === false
                                          ? true
                                          : false
                                      }
                                      checked={atendeAdulto}
                                      onChange={({ target }) => {
                                        setAtendeAdulto(!atendeAdulto);

                                        if (!target?.checked) {
                                          setTotalLeitoUTIAdulto(null);
                                          setTotalEnfermeirosUTIAdulto(null);
                                        }
                                      }}
                                    >
                                      Adulto
                                    </Checkbox>
                                  </CheckboxBg>
                                  {atendeAdulto && (
                                    <Row>
                                      <Col span={24}>
                                        <div style={{ padding: '20px' }}>
                                          <BoxInput>
                                            <Label>Quanto leitos? </Label>
                                            <input
                                              name="totalLeitoUTIAdulto"
                                              type="text"
                                              value={totalLeitoUTIAdulto}
                                              onChange={({ target }) =>
                                                setTotalLeitoUTIAdulto(
                                                  onlyNumbers(target.value)
                                                )
                                              }
                                              ref={register({
                                                required: atendeAdulto
                                                  ? true
                                                  : false,
                                                maxLength: 20,
                                              })}
                                              disabled={
                                                ROLE_ADMIN ||
                                                  desbloqueado === false
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <p>(Somente números)</p>
                                            {errors.totalLeitoUTIAdulto && (
                                              <span className="errorField">
                                                Campo obrigatório.
                                              </span>
                                            )}
                                          </BoxInput>

                                          <br />

                                          <BoxInput>
                                            <Label>
                                              Quantos enfermeiros(as) nesta UTI?
                                            </Label>
                                            <input
                                              name="totalEnfermeirosUTIAdulto"
                                              type="text"
                                              value={totalEnfermeirosUTIAdulto}
                                              onChange={({ target }) =>
                                                setTotalEnfermeirosUTIAdulto(
                                                  target.value
                                                )
                                              }
                                              ref={register({
                                                required: atendeAdulto
                                                  ? true
                                                  : false,
                                                maxLength: 20,
                                              })}
                                              disabled={
                                                ROLE_ADMIN ||
                                                  desbloqueado === false
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <p>(Somente números)</p>
                                            {errors.totalEnfermeirosUTIAdulto && (
                                              <span className="errorField">
                                                Campo obrigatório.
                                              </span>
                                            )}
                                          </BoxInput>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                              {/* ./Pediátrico */}
                            </BoxInput>
                          </Col>
                        </Row>
                      )}
                    </Col>

                    {/* --- */}
                  </Col>
                </Row>

                {/*
                  *
                   ./ 29. Unidades presentes na Instituição:
                  *
                */}

                {/*
                  *
                   30. Quais os serviços de apoio o hospital possui?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      30. Quais os serviços de apoio o hospital possui?{' '}
                      <span>(Marque todas que se aplicam)</span>
                    </Label>

                    <Row>
                      <Col span={24}>
                        <BoxInput>
                          <BoxCheckboxs>
                            <Checkbox.Group
                              style={{ width: '100%' }}
                              onChange={onChangeDiagnosticoTerapeutico}
                              value={diagnosticoTerapeutico}
                              disabled={
                                ROLE_ADMIN || desbloqueado === false
                                  ? true
                                  : false
                              }
                            >
                              <BoxdiagnosticoTerapeutico>
                                <Row>
                                  {opcoesPerfilHospitalar &&
                                    opcoesPerfilHospitalar.map(
                                      ({ grupo, valor, nome, descricao }) => {
                                        const alignTxt =
                                          (String(nome).length < 25 && 26) ||
                                          (String(nome).length < 41 && 21) ||
                                          (String(nome).length > 41 && 13);

                                        if (
                                          grupo === 'diagnotico_terapeutico'
                                        ) {
                                          return (
                                            <Col span={8} key={valor}>
                                              <CheckboxBg
                                                selecionado={
                                                  !!diagnosticoTerapeutico.includes(
                                                    `${valor}`
                                                  )
                                                }
                                              >
                                                <Checkbox value={valor}>
                                                  <p
                                                    id={valor}
                                                    style={{
                                                      top: alignTxt,
                                                      position: 'absolute',
                                                      left: 22,
                                                      fontWeight: 'bold',
                                                    }}
                                                  >
                                                    {nome}
                                                  </p>
                                                </Checkbox>

                                                {valor ===
                                                  'diagnotico_terapeutico_hemodinamica' &&
                                                  diagnosticoTerapeutico.includes(
                                                    'diagnotico_terapeutico_hemodinamica'
                                                  ) && (
                                                    <div className="diagnotico_terapeutico_hemodinamica">
                                                      <BoxInput>
                                                        <Label>
                                                          A unidade funciona 24
                                                          horas por dia e 7 dias
                                                          da semana?
                                                        </Label>
                                                        <Row>
                                                          <Col span={10}>
                                                            <BoxRadios>
                                                              <Radio
                                                                checked={
                                                                  atendimento24Hemodinamica ===
                                                                  true
                                                                }
                                                                onClick={() =>
                                                                  setAtendimento24Hemodinamica(
                                                                    true
                                                                  )
                                                                }
                                                                disabled={
                                                                  ROLE_ADMIN ||
                                                                    desbloqueado ===
                                                                    false
                                                                    ? true
                                                                    : false
                                                                }
                                                              >
                                                                Sim
                                                              </Radio>
                                                            </BoxRadios>
                                                          </Col>

                                                          <Col span={8}>
                                                            <BoxRadios>
                                                              <Radio
                                                                checked={
                                                                  atendimento24Hemodinamica ===
                                                                  false
                                                                }
                                                                onClick={() =>
                                                                  setAtendimento24Hemodinamica(
                                                                    false
                                                                  )
                                                                }
                                                                disabled={
                                                                  ROLE_ADMIN ||
                                                                    desbloqueado ===
                                                                    false
                                                                    ? true
                                                                    : false
                                                                }
                                                              >
                                                                Não
                                                              </Radio>
                                                            </BoxRadios>
                                                          </Col>
                                                        </Row>
                                                      </BoxInput>
                                                    </div>
                                                  )}
                                              </CheckboxBg>
                                            </Col>
                                          );
                                        }
                                      }
                                    )}
                                </Row>
                              </BoxdiagnosticoTerapeutico>
                            </Checkbox.Group>
                          </BoxCheckboxs>
                        </BoxInput>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/*
                  *
                  ./  30. Quais os serviços de apoio o hospital possui?
                  *
                */}

                {/*
                  *
                  31. O Hospital participa de alguma rede assistencial?
                  *
                */}
                <Row>
                  <Col span={24}>
                    <Label>
                      31. O Hospital pertence a algum grupo?
                    </Label>
                    <Row>
                      <Col span={8}>
                        <BoxRadios active={redeAssistencial === true}>
                          <Radio
                            checked={redeAssistencial === true}
                            onClick={() => setRedeAssistencial(true)}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Sim
                          </Radio>
                        </BoxRadios>
                      </Col>

                      <Col span={8}>
                        <BoxRadios active={redeAssistencial === false}>
                          <Radio
                            checked={redeAssistencial === false}
                            onClick={() => {
                              setRedeAssistencial(false);
                              setRedeAssistencialCnpj("");
                              setRedeAssistencialRazao("");
                            }}
                            disabled={
                              ROLE_ADMIN || desbloqueado === false
                                ? true
                                : false
                            }
                          >
                            Não
                          </Radio>
                        </BoxRadios>
                      </Col>
                    </Row>

                    {redeAssistencial ? (
                      ROLE_ADMIN ? (
                        <row>
                          <Col span={24}>
                            <div className="boxRedeAssitencialCnpj">
                              <span>Qual o CNPJ da matriz?</span>
                            </div>
                            <div className="boxRedeAssitencialCnpj">
                              <Col span={6}>
                                <input
                                  value={redeAssistencialCnpj}
                                  name="redeAssistencialCnpj"
                                  min="0"
                                  type="text"
                                  onChange={e =>
                                    setRedeAssistencialCnpj(e.target.value)
                                  }
                                  disabled={
                                    ROLE_ADMIN || desbloqueado === false
                                      ? true
                                      : false
                                  }
                                />
                              </Col>
                            </div>
                            <div className="boxRedeAssitencialRazao">
                              <Col span={8}>
                                <input value={redeAssistencialRazao} disabled={
                                  ROLE_ADMIN || desbloqueado === false
                                    ? true
                                    : false
                                } />
                              </Col>
                            </div>
                          </Col>
                        </row>
                      ) : (
                        <row>
                          <Col span={24}>
                            <div className="boxRedeAssitencialCnpj">
                              <span>Qual o CNPJ da matriz?</span>
                            </div>
                            <div className="boxRedeAssitencialCnpj">
                              <Col span={6}>
                                <input
                                  value={redeAssistencialCnpj}
                                  name="redeAssistencialCnpj"
                                  min="0"
                                  type="text"
                                  onChange={e =>
                                    setRedeAssistencialCnpj(e.target.value)
                                  }
                                  onBlur={e =>
                                    retornarRazaoSocial(e.target.value)
                                  }
                                  disabled={
                                    ROLE_ADMIN || desbloqueado === false
                                      ? true
                                      : false
                                  }
                                />
                              </Col>
                            </div>
                            <div className="boxRedeAssitencialRazao">
                              <Col span={8}>
                                <input value={redeAssistencialRazao} disabled="true" />
                              </Col>
                            </div>
                          </Col>
                        </row>)
                    ) : (
                      <br />
                    )}

                  </Col>
                </Row>
                {/*
                  *
                 ./ 31. O Hospital participa de alguma rede assistencial?
                  *
                */}
              </BoxForm>

              {ROLE_ADMIN || desbloqueado === false ? (
                <ButtonTop>
                  <button type="button" onClick={scrollToTop}>
                    <MdExpandLess /> Voltar para o topo
                  </button>
                </ButtonTop>
              ) : (
                <ButtonBox>
                  <button type="submit">
                    {loading ? 'Enviando dados...' : 'Salvar alterações '}
                  </button>
                </ButtonBox>
              )}

              <br />
              <br />
              <br />
              <br />
            </form>
          </Content>
        </BoxContent>
      )}
    </>
  );
};

export default PerfilDoHospital;
